import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, createElement } from "lwc";
import _tmpl from "./pdfViewerMainPane.html";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, registerListener, unregisterAllListeners, clearTrackedListeners, unregisterListener, registerListenerAndTrack } from 'util/pubsub';
import personaService from "../../data/personaService/personas";

//AHS260511+Claude - Extract HTML content from hidden PDF form fields named <persona>.html
//Replaces the previous embedded-file attachment approach which required PDF.js EmbeddedFiles support
async function extractHtmlFromHiddenFields(doc) {
  const attachments = {};
  for (let pageNum = 1; pageNum <= doc.numPages; pageNum++) {
    const page = await doc.getPage(pageNum);
    const annotations = await page.getAnnotations();
    for (const ann of annotations) {
      if (ann.fieldName && ann.fieldName.toLowerCase().endsWith('.html') && ann.fieldValue) {
        console.log('AHS260511 found HTML hidden field:', ann.fieldName, 'size:', ann.fieldValue.length);
        attachments[ann.fieldName.toLowerCase()] = ann.fieldValue;
      }
    }
  }
  return Object.keys(attachments).length > 0 ? attachments : null;
}
class PdfViewerMainPane extends LightningElementSLDS {
  constructor() {
    super();

    // Signature pad
    // <link rel="stylesheet" type="text/css" href="/kb/views/ipad/sign/assets/jquery.signaturepad.css">
    // <script type="text/javascript" src="/kb/views/ipad/sign/src/jquery.signaturepad.js"></script>
    // <script type="text/javascript" src="/kb/views/ipad/sign/assets/json2.min.js"></script>
    //ORV240924 remove signaturepad.ss and jquery_ui.min as it is imported in index.html
    /*  let sigCss = 'resources/jquery.signaturepad.css';
      const sigStyles = document.createElement('link');
      sigStyles.href = sigCss;
      sigStyles.rel = 'stylesheet';
      this.template.appendChild(sigStyles);
       // Add jQuery (from jQuery CDN)
      // let jQueryUICSS = 'https://code.jquery.com/ui/1.13.1/themes/redmond/jquery-ui.css';
      let jQueryUICSS = 'resources/jQuery/jquery_ui.min.css';
      const jQueryUIStyles = document.createElement('link');
      jQueryUIStyles.href = jQueryUICSS;
      jQueryUIStyles.rel = 'stylesheet';
      this.template.appendChild(jQueryUIStyles);*/

    // Color picker
    // const colorPickerScriptUrl = "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.1/spectrum.min.js";
    this.parentLoadsPdf = false;
    this.sendtotxtval = void 0;
    this.DEFAULT_SCALE = __g_zoomParam;
    //SHR191114 show full size for a better zoom experience //ORV240313 set  __g_zoomParam as DEFAULT_SCALE
    this.___pdfDoc___ = void 0;
    this.__pageInfo___ = {
      curPage: -1,
      // default to -1 to indicate that form elements don't need to be saved
      pageCount: 0,
      curPageView: null,
      canvas: null,
      curZoomScale: this.DEFAULT_SCALE,
      zoomHasChanged: false,
      container: null
    };
    this.__docInfo___ = {
      pagesFormData: {},
      documentFormData: {},
      //ORV250127 maintain unique fields on document level
      isLocked: false
    };
    this.selectedDocType = "Enrollment";
    this.eventFired = false;
    this.isLocalFileUpload = void 0;
    this.localFileData = void 0;
    this.displaywallet = false;
    this.walletSrc = "";
    // This is needed by the pubsub code to assure that events are only sent between components on the same page. We
    // need to come up with some attribute(inis) that we can use to mark the components as belonging to a certain page/application.
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    // zpServer = "https://devcrn.zpaper.com/";
    this.__g_zPDF_formHelper__ = void 0;
    this.__$containerDiv = void 0;
    this.dynamicDialog = null;
    this.loadingDefaultPdf = false;
    this.source = '';
    this.sourceUrl = '';
    //declare helper reference at class level
    this.__formHelper = function () {};
    this.__sigHelper = function () {};
    this.__searchHelper = function () {};
    this.__pdfEventObject = function () {};
    this.__pdfAppObject = function () {};
    this.__dialogHelper = function () {};
    this.isPageLoading = false;
    //check if the page load is in progress
    this.fillOnLoad = false;
    this.selectedPersona = "";
    this.isBookmarkedPDF = false;
    const colorPickerScriptUrl = "resources/spectrum.min.js";
    const colorPickerScript = document.createElement('script');
    colorPickerScript.src = colorPickerScriptUrl;
    this.template.appendChild(colorPickerScript);

    // const colorPickerStyleUrl = "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.css";
    const colorPickerStyleUrl = "resources/spectrum.min.css";
    const colorPickerStyle = document.createElement('link');
    colorPickerStyle.href = colorPickerStyleUrl;
    colorPickerStyle.rel = 'stylesheet';
    this.template.appendChild(colorPickerStyle);

    /*
    let scriptPath = 'https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js';
    const scriptTag = document.createElement('script');
    scriptTag.src = scriptPath;
    this.template.appendChild(scriptTag);
    */

    // Add pdf viewer css
    let pdfViewerCSS = 'resources/pdf_viewer.css';
    const styles = document.createElement('link');
    styles.href = pdfViewerCSS;
    styles.rel = 'stylesheet';
    this.template.appendChild(styles);

    //ahs - Add slick stype start // ORV240923 slick not in user commenting it out
    /*  let slickCSS = 'resources/slick/slick.css';
      const slickStyles = document.createElement('link');
      slickStyles.href = slickCSS;
      slickStyles.rel = 'stylesheet';
      this.template.appendChild(slickStyles);
       let slickThemeCSS = 'resources/slick/slick_theme.css';
      const slickThemeStyles = document.createElement('link');
      slickThemeStyles.href = slickThemeCSS;
      slickThemeStyles.rel = 'stylesheet';
      this.template.appendChild(slickThemeStyles);*/
    //ahs - Add slick stype end

    //ahs - Add zpLib stype start
    let zpLibCSS = 'resources/zpLib/zpLib.css';
    const zpLibStyles = document.createElement('link');
    zpLibStyles.href = zpLibCSS;
    zpLibStyles.rel = 'stylesheet';
    this.template.appendChild(zpLibStyles);
    //ahs - Add zpLib stype end

    //CRN211222 Add pdf functions support library
    let pdfFunctionsJS = 'resources/pdf.functions.js';
    const pdfFunctions = document.createElement('script');
    pdfFunctions.src = pdfFunctionsJS;
    this.template.appendChild(pdfFunctions);
    //CRN211222 Add pdf functions support library - END

    // Add pdf-lib and download libraries
    // <script src="https://unpkg.com/pdf-lib@1.4.0"></script>
    // let pdfLibJS = 'https://unpkg.com/pdf-lib@1.17.1';
    let pdfLibJS = 'resources/pdf-lib.js';
    // let pdfLibJS = 'resources/pdf-lib.min.js';
    const pdfLibEle = document.createElement('script');
    pdfLibEle.src = pdfLibJS;
    this.template.appendChild(pdfLibEle);

    // <script src="https://unpkg.com/downloadjs@1.4.7"></script>
    let downloadJS = 'https://unpkg.com/downloadjs@1.4.7';
    const downloadEle = document.createElement('script');
    downloadEle.src = downloadJS;
    this.template.appendChild(downloadEle);
    // Add pdf-lib and download libraries - END

    //CRN220105 Supporting custom validation javascript inside Acro Fields
    /**
     *  All JavaScript scripts are executed as the result of a particular event. For each of
     *  these events, JavaScript creates an event object. During the occurrence of each event,
     *  you can access this object to get and possibly manipulate information about the current
     *  state of the event.
     *
     *  @class Event
     */
    this.__pdfEventObject.prototype = {
      /**
       *  A string specifying the change in value that the user has just typed. A JavaScript may
       *  replace part or all of this string with different characters. The change may take the form
       *  of an individual keystroke or a string of characters (for example, if a paste into the field
       *  is performed).
       *
       *  @property change
       *  @type {String}
       */
      change: "",
      /**
       *  Used for validation. Indicates whether a particular event in the event chain should
       *  succeed. Set to false to prevent a change from occurring or a value from committing.
       *  The default is true.
       *
       *  @property rc
       *  @type {Boolean}
       *
       */
      rc: true,
      /**
       *  The ending position of the current text selection during a keystroke event.
       *
       *  @property selEnd
       *  @type {Number}
       *  @readOnly
       */
      get selEnd() {
        return AFgetCaret(this.target);
      },
      /**
       *  The starting position of the current text selection during a keystroke event.
       *
       *  @property selStart
       *  @type {Number}
       *  @readOnly
       */
      get selStart() {
        return AFgetCaret(this.target);
      },
      /**
       *  Returns true if errors should be silenced instead of displaying an alert.
       *
       *  @private
       *  @property silenceErrors
       *  @type {Boolean}
       *  @readOnly
       */
      silenceErrors: false,
      /**
       *  The Field object that triggered the calculation event. This object is usually different from the
       *  target of the event, which is the field that is being calculated.
       *
       *  @property source
       *  @type {Object}
       *  @readOnly
       */
      source: null,
      /**
       *  The target object that triggered the event. In all mouse, focus, blur, calculate, validate, and
       *  format events, it is the Field object that triggered the event. In other events, such as page open
       *  and close, it is the Doc or this object.
       *
       *  For now, we'll just make this the DOM element (which we can add properties to just like any other
       *  object). If we find that the event.target object needs certain defined functions, we'll need to wrap
       *  the DOM element in another object just like I was doing (commented-out below).
       *
       *  @property target
       *  @type {Object}
       *  @readOnly
       */
      target: null,
      // targetObj: null,
      // set target(_target) {
      //     // wrap the target in an object since the validating script might be setting properties on the event.target value.
      //     this.targetObj = {};
      //     this.targetObj.targetEle = _target;
      // },
      // get target() {
      //     return this.targetObj.targetEle;
      // },

      /**
       *  Tries to return the name of the target object. Can be used for debugging purposes to help identify
       *  the code causing exceptions to be thrown. Common values of targetName include:
       *
       *    The folder-level script file name for App/Init events
       *    The document-level script name forDoc/Open events
       *    The PDF file name being processed for Batch/Exec events
       *    The field name for Field events
       *    The menu item name for Menu/Exec events
       *    The screen annotation name for Screen events (multimedia events)
       *
       *  @property targetName
       *  @type {String}
       *  @readOnly
       */
      get targetName() {
        return this.target ? $(this.target).attr('name') : null;
      },
      /**
       *  This property has different meanings for different field events:
       *
       *    For the Field/Validate event, it is the value that the field contains when it is committed.
       *    For a combo box, it is the face value, not the export value.
       *
       *    For a Field/Calculate event, JavaScript should set this property. It is the value that the
       *    field should take upon completion of the event.
       *
       *    For a Field/Format event, JavaScript should set this property. It is the value used when generating
       *    the appearance for the field. By default, it contains the value that the user has committed. For a
       *    combo box, this is the face value, not the export value.
       *
       *    For a Field/Keystroke event, it is the current value of the field. If modifying a text field, for
       *    example, this is the text in the text field before the keystroke is applied.
       *
       *    For Field/Blur and Field/Focus events, it is the current value of the field. During these two events,
       *    event.value is read only. That is, the field value cannot be changed by setting event.value.
       *
       *  @property value
       *  @type {Any}
       */
      get value() {
        if (this.internalValue) {
          return this.internalValue;
        }
        if (this.target) {
          let val = $(this.target).val();
          if (val && this.afFormatFunction) {
            try {
              // Let the format function turn the input into just digits (and other supported chars) if needed.
              val = eval('(' + this.afFormatFunction + ')');
              this.internalValue = val;
            } catch (err) {
              console.log("Error invoking " + this.afFormatFunction + ": " + err);
            }
          }
          return val;
        }
        return "";
      },
      set value(_val) {
        if (this.target) {
          $(this.target).val(_val);
        }
      },
      internalValue: null,
      afFormatFunction: null,
      /**
       *  Verifies the current keystroke event before the data is committed. It can be used to check target form
       *  field values to verify, for example, whether character data was entered instead of numeric data. JavaScript
       *  sets this property to true after the last keystroke event and before the field is validated.
       *
       *  @property willCommit
       *  @type {Boolean}
       *  @readOnly
       */
      willCommit: true,
      changeEx: function () {
        console.log('changeEx function called.');
      },
      commitKey: null,
      fieldFull: null,
      keyDown: null,
      modifier: null,
      name: null,
      richChange: function () {
        console.log('richChange function called.');
      },
      richChangeEx: function () {
        console.log('richChangeEx function called.');
      },
      richValue: null,
      shift: null,
      type: null
    };
    /**
     *  A static JavaScript object that represents the Acrobat application. It defines a number
     *  of Acrobat-specific functions plus a variety of utility routines and convenience functions.
     *
     *  @class App
     */
    this.__pdfAppObject.prototype = {
      /**
       *  The language code of the running application.
       *
       *  @property language
       *  @type {String}
       *  @readOnly
       */
      language: "EN",
      /**
       *  The platform the script is currently executing on.
       *
       *  @property platform
       *  @type {String}
       *  @readOnly
       */
      platform: window.navigator.platform,
      /**
       *  Displays an alert dialog box.
       *
       *  @method alert
       *  @param cMsg {String} A string containing the message to be displayed.
       *  @return {Number} The type of button that was tapped by the user: 1-OK, 2-Cancel, 3-No, 4-Yes.
       */
      alert: function (cMsg, nIcon) {
        AFErrorMessage(cMsg);
      },
      /**
       *
       *  @private
       *  @method beep
       *  @param nType {Number}
       */
      beep: function (nType) {
        AFBeep();
      }
    };
    //CRN220105 Supporting custom validation javascript inside Acro Fields - END
    Object.defineProperty(String.prototype, 'endsWith', {
      value: function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
      },
      enumerable: false // this is actually the default
    });
    Object.defineProperty(String.prototype, 'startsWith', {
      value: function (prefix) {
        return 0 == this.indexOf(prefix);
      },
      enumerable: false // this is actually the default
    });
    Object.defineProperty(String.prototype, 'contains', {
      value: function (str) {
        return this.indexOf(str) >= 0;
      },
      enumerable: false // this is actually the default
    });
    Object.defineProperty(Array.prototype, 'contains', {
      value: function (ele) {
        return this.indexOf(ele) >= 0;
      },
      enumerable: false // this is actually the default
    });
    const __incrementalMatcher = function () {};
    __incrementalMatcher.prototype = {
      id: 1,
      wordToMatch: null,
      matchType: 0,
      charsMatched: 0,
      matchList: [],
      NO_MATCH: 0,
      INCREMENTAL_MATCH: 1,
      COMPLETE_MATCH: 2,
      CHARACTERS_TO_NORMALIZE: {
        '\u2018': '\'',
        '\u2019': '\'',
        '\u201A': '\'',
        '\u201B': '\'',
        '\u201C': '"',
        '\u201D': '"',
        '\u201E': '"',
        '\u201F': '"',
        '\xBC': '1/4',
        '\xBD': '1/2',
        '\xBE': '3/4'
      },
      NORMALIZE_KEYS: null,
      _normalizationRegex: null,
      _normalize: function (text) {
        if (!this.NORMALIZE_KEYS) {
          this.NORMALIZE_KEYS = Object.keys(this.CHARACTERS_TO_NORMALIZE).join('');
          this._normalizationRegex = new RegExp('[' + this.NORMALIZE_KEYS + ']', 'g');
        }
        return text.replace(this._normalizationRegex, ch => {
          return this.CHARACTERS_TO_NORMALIZE[ch];
        });
      },
      setWordToMatch: function (word) {
        this.wordToMatch = word.toLowerCase();
      },
      initialize: function (resetId) {
        this.matchList = [];
        this.charsMatched = 0;
      },
      isIncrementalMatch: function ($div) {
        let text = this._normalize($div.text()).toLowerCase();
        if (0 === text.length) {
          this.initialize();
          return this.NO_MATCH;
        }
        if (0 === this.charsMatched) {
          // first attempted incremental match
          if (text.contains(this.wordToMatch)) {
            this.matchList.push({
              id: this.id++,
              $ele: $div,
              matchIdx: text.indexOf(this.wordToMatch),
              matchLength: this.wordToMatch.length
            });
            return this.COMPLETE_MATCH;
          }
          // Check to see if part of the wordToMatch is found in the current div text (since the text didn't contain
          // the word we're searching for, the part must be found at the end of the current run text, if at all)
          const startWordLength = Math.min(text.length, this.wordToMatch.length);
          let wordToCheck = this.wordToMatch.substring(0, startWordLength);
          while (wordToCheck.length > 0) {
            if (text.endsWith(wordToCheck)) {
              this.charsMatched = wordToCheck.length;
              let matchIdx = text.lastIndexOf(wordToCheck);
              this.matchList.push({
                id: this.id,
                $ele: $div,
                matchIdx: matchIdx,
                matchLength: text.length - matchIdx
              });
              return this.INCREMENTAL_MATCH;
            }
            wordToCheck = wordToCheck.substring(0, wordToCheck.length - 1);
          }
          this.initialize();
          return this.NO_MATCH;
        }
        // This is a continuation of an incremental match search. The next piece must start with whatever is left over of our match word.
        let charsLeftToMatch = this.wordToMatch.length - this.charsMatched;
        let wordLeftToMatch = this.wordToMatch.substring(this.charsMatched);
        if (charsLeftToMatch > text.length) {
          if (!wordLeftToMatch.startsWith(text)) {
            this.initialize();
            return this.NO_MATCH;
          }
          // We have more matched chars, continue.
          this.matchList.push({
            id: this.id,
            $ele: $div,
            matchIdx: 0,
            matchLength: text.length
          });
          this.charsMatched += text.length;
          return this.INCREMENTAL_MATCH;
        }
        if (!text.startsWith(wordLeftToMatch)) {
          this.initialize();
          return this.NO_MATCH;
        }
        // If the current text starts with the word we're looking for, it must contain the entire word (and possibly more), so we're done.
        this.matchList.push({
          id: this.id,
          $ele: $div,
          matchIdx: 0,
          matchLength: wordLeftToMatch.length
        });
        this.charsMatched += this.wordToMatch.length;
        return this.COMPLETE_MATCH;
      }
    };
    this.__searchHelper.prototype = {
      parent: this,
      searchTerm: null,
      startPage: 1,
      matchId: 1,
      $pageContents: null,
      // pageText: null,
      divList: null,
      matchesOnPage: [],
      // list that will allow us to scroll match into view
      CHARACTERS_TO_NORMALIZE: {
        '\u2018': '\'',
        '\u2019': '\'',
        '\u201A': '\'',
        '\u201B': '\'',
        '\u201C': '"',
        '\u201D': '"',
        '\u201E': '"',
        '\u201F': '"',
        '\xBC': '1/4',
        '\xBD': '1/2',
        '\xBE': '3/4'
      },
      NORMALIZE_KEYS: null,
      _normalizationRegex: null,
      _normalize: function (text) {
        if (!this.NORMALIZE_KEYS) {
          this.NORMALIZE_KEYS = Object.keys(this.CHARACTERS_TO_NORMALIZE).join('');
          this._normalizationRegex = new RegExp('[' + this.NORMALIZE_KEYS + ']', 'g');
        }
        return text.replace(this._normalizationRegex, ch => {
          return this.CHARACTERS_TO_NORMALIZE[ch];
        });
      },
      _clearHighlights: function () {
        this.$pageContents.find("span").each(function () {
          let $span = $(this);
          let $div = $span.parent();
          // Lucky for us, jQuery preserves the text() value when we set the html() value, so we just have to restore html() from text().
          $div.html($div.text());
        });
      },
      search: function (srchText) {
        if (srchText === this.searchTerm) {
          if (this._scrollMatchIntoView()) {
            return;
          }
          // We must've viewed all matches, jump to next page to continue the search.
          if (window.__g_zPDF_formHelper__.pagesInfo.pageCount > 1) {
            let nextPage = window.__g_zPDF_formHelper__.pagesInfo.curPage + 1;
            if (nextPage > window.__g_zPDF_formHelper__.pagesInfo.pageCount) {
              nextPage = 1;
            }
            window.__g_zPDF_formHelper__.mainPane.queueRenderPage(nextPage);
            let pageLoadInterval = setInterval(() => {
              if (!window.__g_zPDF_formHelper__.mainPane.isPageLoading) {
                // $(".loading-overlay").fadeOut();
                this.$pageContents = null;
                // Fire an event to the thumbnails so that they follow along.
                console.log("Parent pageRef: ", this.parent.pageRef);
                fireEvent(this.parent.pageRef, eventTypes.PDF_PAGE_CHANGED, {
                  type: eventTypes.PDF_PAGE_CHANGED,
                  detail: {
                    pageNumber: nextPage,
                    source: "word-search"
                  }
                });
                if (!this._doSearch(srchText) && nextPage !== this.startPage) {
                  // Not found on the current page, any more pages to search?
                  nextPage += 1;
                  if (nextPage > window.__g_zPDF_formHelper__.pagesInfo.pageCount) {
                    nextPage = 1;
                  }
                  window.__g_zPDF_formHelper__.mainPane.queueRenderPage(nextPage);
                  return; // Don't clear the interval yet; we didn't find any matches on this page.
                }
                clearInterval(pageLoadInterval);
                if (nextPage === this.startPage) {
                  this.searchTerm = null;
                  // We've gone through the whole document.
                  showInfo("Search complete.", 5500);
                }
                return;
              }
            }, 500);
          } else {
            showInfo("Search complete.", 5500);
          }
        } else {
          this.$pageContents = null;
          this.searchTerm = null;
          this.startPage = window.__g_zPDF_formHelper__.pagesInfo.curPage;
          if (!this._doSearch(srchText)) {
            // If nothing was found continue searching in case there are more pages.
            this.searchTerm = srchText;
            this.search(srchText);
          }
        }
      },
      _doSearch: function (srchText) {
        if (!this.$pageContents) {
          this.$pageContents = window.__g_zPDF_formHelper__.lwcTemplate.querySelector(".textLayer");
          if (!this.$pageContents) {
            // This pdf must only be made up of images.
            alert("The current pdf document contains only images. Searching is not possible"); // ToDo: make this a dialog.
            return;
          }
          this.matchId = 1;
          this.$pageContents = $(this.$pageContents);
        } else if (srchText !== this.searchTerm) {
          // Clear any previous search results.
          this._clearHighlights();
        }
        this.searchTerm = srchText;
        let matchesWithLength = this._searchInternal(srchText);
        if (matchesWithLength.length > 0) {
          this._highlightMatches(matchesWithLength);
          this._scrollMatchIntoView();
          return true;
        }
        return false;
      },
      _scrollMatchIntoView: function () {
        if (this.matchId > 1) {
          $(window.__g_zPDF_formHelper__.lwcTemplate.querySelector('[data-id="match_' + (this.matchId - 1) + '"]')).removeClass('selected');
        }
        let ele = window.__g_zPDF_formHelper__.lwcTemplate.querySelector('[data-id="match_' + this.matchId + '"]');
        if (ele) {
          this.matchId++;
          $(ele).addClass('selected');
          ele.scrollIntoView({
            behavior: "smooth"
          });
          return true;
        }
        return false;
      },
      _searchInternal: function (query) {
        let matchesWithLength = [];
        var queryArray = query.match(/\S+/g);
        for (let i = 0; i < queryArray.length; i++) {
          let subQuery = queryArray[i];
          let queryLen = subQuery.length;
          let matchIdx = -queryLen;
          let self = this;
          let incrementalMatcher = new __incrementalMatcher();
          incrementalMatcher.setWordToMatch(subQuery);
          this.$pageContents.children('div').each(function (idx) {
            let matchValue = incrementalMatcher.isIncrementalMatch($(this));
            if (incrementalMatcher.COMPLETE_MATCH === matchValue) {
              matchesWithLength.push(...incrementalMatcher.matchList);
              incrementalMatcher.initialize();
            }
          });
        }
        return matchesWithLength;
      },
      _highlightMatches: function (matchesWithLength) {
        let curIdx = 0;
        let divIdx = 0;
        for (let idx = 0; idx < matchesWithLength.length; idx++) {
          let match = matchesWithLength[idx];
          let text = match.$ele.text();
          let matchEnd = match.matchIdx + match.matchLength;
          match.$ele.html((match.matchIdx > 0 ? text.substring(0, match.matchIdx) : "") + "<span data-id='match_" + match.id + "' class='highlight'>" + text.substring(match.matchIdx, matchEnd) + "</span>" + (matchEnd < text.length ? text.substring(matchEnd) : ""));
        }
      }
    };
    this.__formHelper.prototype = {
      addInk: "'addInk',",
      destination: null,
      esigData: [],
      saveEsigData: function (data) {
        const {
          name,
          username,
          initials,
          date,
          reason,
          sticker,
          eRxData: {
            prescriptions,
            tracking
          }
        } = data;
        this.esigData.push({
          "signerName": name,
          "username": username,
          "signerInitials": initials,
          "signatureReason": reason,
          "signatureDate": date,
          "ink": sticker,
          eRxData: {
            "tracking": tracking,
            "prescriptions": prescriptions
          }
        });
      },
      addESigDataToFormSubmission: function (formData) {
        this.esigData.forEach(function (esigData, index) {
          formData.append(`X_esig${index + 1}`, JSON.stringify(esigData));
        });
      },
      search: function (findStr) {
        window.__g_zPDF_searchHelper__.search(findStr);
      },
      parseCoordinates: function (markup) {
        // kbm('IMG5','PAGE2IMG5','addInk',300,100,92,262,'68,...
        let idxInk = markup.indexOf(this.addInk);
        if (idxInk > 0) {
          idxInk += this.addInk.length;
          let idxEnd = markup.indexOf(",'", idxInk);
          if (idxEnd > idxInk) {
            // keep the 'PAGE...' part also
            let str = markup.substring(0, idxEnd);
            let parts = str.split(',');
            return parts[1] + ',' + parts[3] + ',' + parts[4] + ',' + parts[5] + ',' + parts[6];
          }
        }
        return markup;
      },
      preserveCurPageFormElements: function (pageNumber, __docInfo___, enforceRequiredFields) {
        let previousFormElements = __docInfo___.pagesFormData[pageNumber];
        let formElements = {};
        console.log("$this ", formElements);

        //let $form = $('#formContainer');//id is updated by salesforce
        //using global variable __g_zPDF_formHelper__ to access the main pane template
        //and replacing id with class
        //let $form = $(__g_zPDF_formHelper__.lwcTemplate.querySelectorAll(".formContainer"));
        let xrayContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".x-ray-content");
        let mainPaneContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".main-pane-content");
        let $form;
        let selectorPostfix = "";

        //if main pane is not hidden, learn from main pane
        if (!mainPaneContent.classList.contains("slds-hidden")) {
          $form = $(mainPaneContent);
        }
        //if x-ray is not hidden, do not learn from x-ray
        else if (!xrayContent.classList.contains("slds-hidden")) {
          //for reading from x-ray div
          //reset the $form variable to point to the x-ray div
          //add data-page-number filter to input
          $form = $(xrayContent);
          selectorPostfix = "[data-page-num='" + pageNumber + "']";
        }

        //let $form = $(this.template.querySelector('.formContainer'));//replacing id with class
        let _self = this;
        // get all <input> elements
        let selectedPersona = getSelectedPersona();
        $form.find('input' + selectorPostfix).each(function () {
          const $this = $(this);
          //ERS241116 too noisy console.log("$this[0] ", $this[0] );
          //   _self.lockFields($this,selectedPersona);
          //ORV241028 get all the signature fields on call of preserveCurPageFormElements and store it in  __g_zPDF_signatureHelper__.signatureinput which is later used in xray
          if ('signature' === $this.data('widgetType')) {
            console.log("in this", $this.val());
            if (!__g_zPDF_signatureHelper__.signatureinput) {
              __g_zPDF_signatureHelper__.signatureinput = {};
            }
            if (!__g_zPDF_signatureHelper__.signatureinput[pageNumber]) {
              __g_zPDF_signatureHelper__.signatureinput[pageNumber] = [];
            }
            const existingNames = __g_zPDF_signatureHelper__.signatureinput[pageNumber].map(input => input.name);
            if (!existingNames.includes($this[0].name)) {
              __g_zPDF_signatureHelper__.signatureinput[pageNumber].push($this[0]);
            }
          }

          // Added is(":visible") so that hidden fields can't be considered required. The ContactFax was required
          // but was hidden by Eric's toolbar code so the user could never submit the form. Eric's toolbar code
          // is actually hiding the ContactFax field's parent (not the field itself), but is(":visible") is
          // supposed to return false if any one of an element's ancestors is not visible. I'm doing the
          // is(":visible") check last because it is a slow operation.
          if (enforceRequiredFields && ($this.data('required') || "true" === $this.data('required')) && $this.is(":visible")) {
            let sigImageFound = false;
            if ('signature' === $this.data('widgetType')) {
              sigImageFound = $this.parent().find('.signatureImage').length > 0;
            }
            if (!$this.val() && !sigImageFound) {
              throw "Required fields not completed.";
            }
          }

          //CRN230316 Do not preserve "Sign Here" input fields.
          if (!this.dataset || !this.dataset.widgetType || 'signature' !== this.dataset.widgetType) {
            let type = $this.attr('type');
            let key = $this.attr('name');
            //  +
            //  ('radio' === type || 'checkbox' === type ? '-' + $this.val() : '') +
            //  ($this.data('annotation-id') ? '-' + $this.data('annotation-id') : ''); //ORV250127 why?
            let formElement = _self.collectEleProps($this);
            formElement.$ele = $this;
            // It is possible to have multiple input fields with the same name (kids fields that the PDF ties
            // together so that a change to one changes all of them). Don't overwrite fields that have a value
            // unless the field is a radio button and the current element is checked.
            if (!formElements[key] || !formElements[key].value || 'radio' === type && formElement.checked) {
              formElements[key] = formElement;
            }
          }
        });
        // get all <select> elements
        $form.find('select' + selectorPostfix).each(function () {
          let $this = $(this);
          let formElement = _self.collectEleProps($this);
          formElement.$ele = $this;

          // It is possible to have multiple input fields with the same name (kids fields that the PDF ties
          // together so that a change to one changes all of them). Don't overwrite fields that have a value.
          if (!formElements[$this.attr('name')] || !formElements[$this.attr('name')].value) {
            formElements[$this.attr('name')] = formElement;
          }
          // Added is(":visible") so that hidden fields can't be considered required. The ContactFax was required
          // but was hidden by Eric's toolbar code so the user could never submit the form. Eric's toolbar code
          // is actually hiding the ContactFax field's parent (not the field itself), but is(":visible") is
          // supposed to return false if any one of an element's ancestors is not visible. I'm doing the
          // is(":visible") check last because it is a slow operation.
          if (enforceRequiredFields && ($this.data('required') || "true" === $this.data('required')) && $this.is(":visible")) {
            if (!this.val() || 'none' === this.val().toLowerCase()) {
              throw "Required fields not completed.";
            }
          }
          //   _self.lockFields($this,selectedPersona);
        });
        // get all <textarea> elements
        $form.find('textarea' + selectorPostfix).each(function () {
          let $this = $(this);
          if (!$this.hasClass("donotPreserve")) {
            let formElement = _self.collectEleProps($this);
            formElement.$ele = $this;
            // It is possible to have multiple input fields with the same name (kids fields that the PDF ties
            // together so that a change to one changes all of them). Don't overwrite fields that have a value.
            if (!formElements[$this.attr('name')] || !formElements[$this.attr('name')].value) {
              formElements[$this.attr('name')] = formElement;
            }
            // Added is(":visible") so that hidden fields can't be considered required. The ContactFax was required
            // but was hidden by Eric's toolbar code so the user could never submit the form. Eric's toolbar code
            // is actually hiding the ContactFax field's parent (not the field itself), but is(":visible") is
            // supposed to return false if any one of an element's ancestors is not visible. I'm doing the
            // is(":visible") check last because it is a slow operation.
            if (enforceRequiredFields && ($this.data('required') || "true" === $this.data('required')) && !this.val() && $this.is(":visible")) {
              throw "Required fields not completed.";
            }
          }
          //   _self.lockFields($this,selectedPersona);
        });
        // finally get all of the signatures ToDo: check for required signatures.
        $form.find('.signatureImage').each(function () {
          const $this = $(this);
          const $parent = $this.parent();
          const $inputSibling = $parent.find('input');
          const eleInfo = _self.collectEleProps($this);
          eleInfo.data = $this.data();
          eleInfo.id = $this.attr('id');
          eleInfo.src = $this.attr('src');
          eleInfo.parentTop = $parent.css('top');
          eleInfo.height = $this.css('height');
          eleInfo.annotationId = $this.parent().children('input').data('annotation-id');
          eleInfo.$ele = $this;
          const key = $inputSibling.attr('name') + '-' + $inputSibling.data('annotation-id');
          formElements[key] = eleInfo;
        });
        if (__docInfo___.pagesFormData[pageNumber]) {
          //ORV250127 loop over formelements and and get unique fields in key value pairs({element Name : element value }) in documentFormData
          for (let key in formElements) {
            if (formElements.hasOwnProperty(key)) {
              if ('radio' === formElements[key].type || 'checkbox' === formElements[key].type) {
                __docInfo___.documentFormData[key] = {
                  name: formElements[key].name,
                  value: formElements[key].value,
                  type: formElements[key].type,
                  checked: formElements[key].checked
                };
              } else {
                __docInfo___.documentFormData[key] = {
                  name: formElements[key].name,
                  value: formElements[key].value,
                  type: formElements[key].type
                };
              }
            }
          }
        }
        __docInfo___.pagesFormData[pageNumber] = formElements;
      },
      updateCurPageFormElements: function (pageNumber, __docInfo___) {
        let formElements = __docInfo___.pagesFormData[pageNumber];

        //let $form = $('#formContainer');//id is updated by salesforce
        //using global variable __g_zPDF_formHelper__ to access the main pane template
        //and replacing id with class
        //let $form = $(__g_zPDF_formHelper__.lwcTemplate.querySelectorAll(".formContainer"));
        let xrayContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".x-ray-content");
        let mainPaneContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".main-pane-content");
        let $form;
        let selectorPostfix = "";

        //if main pane is not hidden, learn from main pane
        if (!mainPaneContent.classList.contains("slds-hidden")) {
          $form = $(mainPaneContent);
        }
        //if x-ray is not hidden, do not learn from x-ray
        else if (!xrayContent.classList.contains("slds-hidden")) {
          //for reading from x-ray div
          //reset the $form variable to point to the x-ray div
          //add data-page-number filter to input
          $form = $(xrayContent);
          selectorPostfix = "[data-page-num='" + pageNumber + "']";
        }

        //let $form = $(this.template.querySelector('.formContainer'));//replacing id with class
        let _self = this;
        // get all <input> elements
        $form.find('input' + selectorPostfix).each(function () {
          let $this = $(this);
          //CRN230316 Do not preserve "Sign Here" input fields.
          if (!this.dataset || !this.dataset.widgetType || 'signature' != this.dataset.widgetType) {
            let type = $this.attr('type');
            let key = $this.attr('name') + ('radio' === type || 'checkbox' === type ? '-' + $this.val() : '') + ($this.data('annotation-id') ? '-' + $this.data('annotation-id') : '');
            formElements[key] = _self.collectEleProps($this, formElements[key]);
            // sync documentFormData so restoreCurPageFormElements paints x-ray edits not original values
            let nameKey = $this.attr('name');
            if ('radio' === type || 'checkbox' === type) {
              __docInfo___.documentFormData[nameKey] = {
                name: formElements[key].name,
                value: formElements[key].value,
                type: formElements[key].type,
                checked: formElements[key].checked
              };
            } else {
              __docInfo___.documentFormData[nameKey] = {
                name: formElements[key].name,
                value: formElements[key].value,
                type: formElements[key].type
              };
            }
          }
        });
        // get all <select> elements
        $form.find('select' + selectorPostfix).each(function () {
          let $this = $(this);
          let nameKey = $this.attr('name');
          formElements[nameKey] = _self.collectEleProps($this, formElements[nameKey]);
          __docInfo___.documentFormData[nameKey] = {
            name: formElements[nameKey].name,
            value: formElements[nameKey].value,
            type: formElements[nameKey].type
          };
        });
        // get all <textarea> elements
        $form.find('textarea' + selectorPostfix).each(function () {
          let $this = $(this);
          if (!$this.hasClass("donotPreserve")) {
            let nameKey = $this.attr('name');
            formElements[nameKey] = _self.collectEleProps($this, formElements[nameKey]);
            __docInfo___.documentFormData[nameKey] = {
              name: formElements[nameKey].name,
              value: formElements[nameKey].value,
              type: formElements[nameKey].type
            };
          }
        });
        // finally get all of the signatures
        $form.find('.signatureImage').each(function () {
          let $this = $(this);
          let $parent = $this.parent();
          let $pleaseSignBtn = $parent.children("input");
          let key = $pleaseSignBtn.attr('name') + ($pleaseSignBtn.data('annotation-id') ? '-' + $pleaseSignBtn.data('annotation-id') : '');
          if (pageNumber == $pleaseSignBtn.data('page-num')) {
            let eleInfo = _self.collectEleProps($this, formElements[key]);
            eleInfo.data = $this.data();
            eleInfo.id = $this.attr('id');
            eleInfo.src = $this.attr('src');
            eleInfo.parentTop = $parent.css('top');
            eleInfo.height = $this.css('height');
            eleInfo.marginTop = $this.css('margin-top');
            eleInfo.annotationId = $pleaseSignBtn.data('annotation-id');
            // formElements[$parent.attr('data-annotation-id')] = eleInfo;
            formElements[key] = eleInfo;
          }
        });
      },
      addRequiredStylingIfNecessary: function ($ele) {
        if ($ele.data("required")) {
          // this will pull (as a boolean, not a string) the data-required attribute from the element
          // add the input-required class to our <section> parent to place a border around the element
          $ele.parent().addClass("input-required");
        }
      },
      addValidation: function (formContainer) {
        //CRN211220 Adding support for required fields and validation
        let self = this;
        let $form = $(__g_zPDF_formHelper__.lwcTemplate.querySelectorAll(".formContainer"));

        //adding support for x-ray div
        if (formContainer) {
          $form = formContainer;
        }

        // Iterate through DOM elements looking for required fields and validation.
        $form.find('input').each(function () {
          let $this = $(this);
          // Get the format and keystroke handlers, if any
          // Add format handlers before validation handlers so that we are guaranteed that format handlers are
          // called before validation handlers (jQuery will guarantee that).
          let fHandler = $this.data("fhandler");
          if (fHandler) {
            // if the input field doesn't have an id (data-id), add it here
            let id = $this.attr('data-id');
            if (!id) {
              id = $this.attr('name') + '-' + new Date().getTime();
              $this.attr('data-id', id);
            }
            fHandler = atob(fHandler);
            fHandler = fHandler.substring(0, fHandler.lastIndexOf(')')); // strip off the closing paren of function call
            $this.blur(() => {
              eval('(' + fHandler + ',"' + id + '"))');
            });
            // also add a onfocus handler to all the value to be reverted if needed
            $this.focus(() => {
              eval('(' + fHandler + ',"' + id + '", true))');
            });
          }
          let vHandler = $this.data("vhandler");
          if (vHandler) {
            // if the input field doesn't have an id (data-id), add it here
            let id = $this.attr('data-id');
            if (!id) {
              id = $this.attr('name') + '-' + new Date().getTime();
              $this.attr('data-id', id);
            }
            vHandler = atob(vHandler);
            // Is the vHandler a function call or just a snippet of script?
            let isFunctionCall = vHandler.indexOf('AFRange_Validate(') >= 0;
            $this.blur(evt => {
              // initialize app and event objects that custom validation handler javascript will use
              let app = new self.pdfAppObject();
              let event = new self.pdfEventObject();
              event.afFormatFunction = null;
              event.internalValue = null;
              if (fHandler) {
                let underscoreIdx = fHandler.indexOf('_');
                let validationFunction = fHandler.substring(0, underscoreIdx + 1) + "getValueForCustomValidation(";
                event.afFormatFunction = validationFunction + '"' + id + '")';
              }
              let eleIdStr = `input[data-id="${id}"]`;
              event.target = self.lwcTemplate.querySelector(eleIdStr);
              // Create a proxy for the color object so that getters will just return the property name as the value.
              // That allows us to support whatever color the validation code might use.
              let color = new Proxy({}, {
                get(target, name, receiver) {
                  return name;
                },
                set(target, name, value, receiver) {
                  // Do nothing for setters, this is a read-only object.
                }
              });
              try {
                if (isFunctionCall) {
                  // strip off the closing paren of function call
                  vHandler = vHandler.substring(0, vHandler.lastIndexOf(')'));
                  eval('(' + vHandler + ',"' + id + '"))');
                } else {
                  eval('((function() {' + vHandler + '})())');
                }
                // Get the targetObj to see if the validation script requested any styling on the target element.
                if (event.target.textColor) {
                  $(event.target).css('color', event.target.textColor);
                }
                if (!app.rc) {
                  // ToDo: clear the field
                }
              } catch (err) {
                AFErrorMessage(err);
              }
            });
          }
          let kHandler = $this.data("khandler");
          if (kHandler) {
            // if the input field doesn't have an id (data-id), add it here
            let id = $this.attr('data-id');
            if (!id) {
              id = $this.attr('name') + '-' + new Date().getTime();
              $this.attr('data-id', id);
            }
            kHandler = atob(kHandler);
            kHandler = kHandler.substring(0, kHandler.lastIndexOf(')')); // strip off the closing paren of function call

            $this.keypress(event => {
              if (event.key && 1 === event.key.length) {
                // ignore shift, ctrl, etc. keys
                if (!eval('(' + kHandler + ',"' + event.key + '","' + $this.val() + '","' + id + '"))')) {
                  AFBeep();
                  event.preventDefault();
                }
              }
            });
          }
          self.addRequiredStylingIfNecessary($this);
        });
        // Handle selects also
        $form.find('select').each(function () {
          self.addRequiredStylingIfNecessary($(this));
        });
        // Handle textareas also
        $form.find('textarea').each(function () {
          self.addRequiredStylingIfNecessary($(this));
        });
      },
      restoreCurPageFormElements: function (pageNumber, __docInfo___) {
        let selectedPersona = getSelectedPersona();
        let formElements = __docInfo___.pagesFormData[pageNumber];
        if (!formElements) {
          //ORV250127 if formelements are not available for cur page then preserve the page before restoring it
          this.preserveCurPageFormElements(pageNumber, __docInfo___);
          formElements = __docInfo___.pagesFormData[pageNumber];
        }
        let documentFormData = __docInfo___.documentFormData;
        if (formElements) {
          let _self = this;
          //let $form = $('#formContainer');//id is updated by salesforce
          //using global variable __g_zPDF_formHelper__ to access the main pane template
          //and replacing id with class
          //let $form = $(__g_zPDF_formHelper__.lwcTemplate.querySelectorAll(".formContainer"));
          let xrayContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".x-ray-content");
          let mainPaneContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".main-pane-content");
          let $form;
          let selectorPostfix = "";

          //if main pane is not hidden, learn from main pane
          if (!mainPaneContent.classList.contains("slds-hidden")) {
            $form = $(mainPaneContent);
          }
          //if x-ray is not hidden, do not learn from x-ray
          else if (!xrayContent.classList.contains("slds-hidden")) {
            //for reading from x-ray div
            //reset the $form variable to point to the x-ray div
            //add data-page-number filter to input
            $form = $(xrayContent);
            selectorPostfix = "[data-page-num='" + pageNumber + "']";
          }
          // restore all <input> elements
          $form.find('input' + selectorPostfix).each(function () {
            let $this = $(this);
            let key = $this.attr('name'); //+

            //AHS251202 - adding null check to avoid signature form field issue (signing on two pages, causes the first one to loose signatures)
            if (!formElements[key]) {
              return;
            }
            _self.lockFields($this, selectedPersona);
            if (documentFormData[key] && 'radio' === formElements[key]?.type) {
              formElements[key].checked = documentFormData[key].checked;
              formElements[key].value = documentFormData[key].value;
            } else if (documentFormData[key] && 'checkbox' === formElements[key]?.type) {
              formElements[key].checked = documentFormData[key].checked;
            } else if (documentFormData.hasOwnProperty(key)) {
              formElements[key].value = documentFormData[key]?.value;
            }
            _self.restoreEleProps($this, formElements[key]);
          });
          $form.find('select' + selectorPostfix).each(function () {
            let $this = $(this);
            console.log("select", $this[0]);
            _self.lockFields($this, selectedPersona);
            if (documentFormData.hasOwnProperty($this.attr('name'))) {
              //ORV250127 copy over checkbox values in form elements from  documentFormData
              formElements[$this.attr('name')].value = documentFormData[$this.attr('name')]?.value;
            }
            _self.restoreEleProps($(this), formElements[$this.attr('name')]);
          });
          // restore all <textarea> elements
          $form.find('textarea' + selectorPostfix).each(function () {
            let $this = $(this);
            console.log("textarea", $this[0]);
            _self.lockFields($this, selectedPersona);
            if (!$this.hasClass("donotPreserve")) {
              if (documentFormData.hasOwnProperty($this.attr('name'))) {
                //ORV250127 copy over checkbox values in form elements from  documentFormData
                formElements[$this.attr('name')].value = documentFormData[$this.attr('name')]?.value;
              }
              _self.restoreEleProps($(this), formElements[$this.attr('name')]);
            }
          });
          // finally restore all of the signatures
          $form.find('.sigWidgetAnnotation').each(function () {
            const $this = $(this);
            const $sigImg = $this.find('img');
            const $pleaseSignBtn = $this.children('input');
            let eleInfo = formElements[$pleaseSignBtn.attr('name') + '-' + $pleaseSignBtn.data('annotation-id')];
            /*
              let signEle = this.querySelector('input[type="button"][data-widget-type="signature"]'); //ORV241028 get the signature element so it can we restored
              let signatureInputProps; //ORV241028 signatureInputProps stores old element properties
              let signatureInputs = __g_zPDF_signatureHelper__.signatureinput?.[pageNumber]; //ORV241028 get old signature inputs
               signatureInputs?.forEach(signatureInput => {
                  if (signatureInput.name ==  signEle.name) {
                      signatureInputProps = signatureInput;
                  }
              });
              if (signEle && signatureInputProps){
                  _self.restoreEleProps(signEle,signatureInputProps);
              }
              */

            // CRN230316 Show the signature image if it already exists, otherwise restore it and show it.
            if ($sigImg.length > 0) {
              $pleaseSignBtn.hide();
              if (eleInfo) {
                $sigImg.parent().css('top', eleInfo.parentTop);
                $sigImg.css('height', eleInfo.height);
              }
              $sigImg.show();
            } else {
              if (eleInfo) {
                $this.css('top', eleInfo.parentTop);
                let $img = $('<img>').attr({
                  id: eleInfo.id,
                  src: eleInfo.src
                });
                $img.data(eleInfo.data);
                // $img.css('width', eleInfo.width ? eleInfo.width : $this.css('width'));
                $img.css('height', eleInfo.height);
                $img.addClass('signatureImage');
                // hide the please sign... button if the user has already signed here.
                // If we found data preserved, that means this element was signed.
                $pleaseSignBtn.hide();
                $this.append($img);
              }
            }
          });
        }
      },
      addAllFormElements: function (htmlFormData) {
        for (let curEle of Object.values(this.docInfo.documentFormData)) {
          if (('radio' !== curEle.type && 'checkbox' !== curEle.type || curEle.checked) && !htmlFormData.has(curEle.name)) {
            htmlFormData.append(curEle.name, curEle.value);
          }
        }
      },
      addViewedFormElements: function (curPageNumber, htmlFormData = new FormData()) {
        //AHS250123 - add htmlFormData param (defualt it to an empty object)
        for (var i = 1; i <= this.pagesInfo.pageCount; i++) {
          //AHS250123 - we are already capturing elements on current page we can skip this iteration
          if (i === curPageNumber) {
            continue;
          }

          //AHS250123 - for rest of the pages, capture elements and add it to htmlFormData
          let formElements = this.docInfo.pagesFormData[i];
          if (!formElements) {
            continue;
          }
          for (let curEle of Object.values(formElements)) {
            if (('radio' !== curEle.type && 'checkbox' !== curEle.type || curEle.checked) && !htmlFormData.has(curEle.name)) {
              htmlFormData.append(curEle.name, curEle.value);
            }
          }
        }
        return htmlFormData;
      },
      collectEleProps: function ($ele, eleProps) {
        let type = $ele.attr('type'); // get the <input> tag type (button, text, etc)
        if (eleProps) {
          if ('radio' === type || 'checkbox' === type) {
            eleProps.checked = $ele.is(':checked');
          }
          eleProps.value = $ele.val();
          eleProps.dataset = $ele.data();
          return eleProps;
        }
        let curEleProps = {};
        curEleProps.tagName = $ele.prop("tagName");
        if (!type) {
          type = curEleProps.tagName.toLowerCase();
        } // select elements don't have a type field
        curEleProps.type = type;
        if ('radio' === type || 'checkbox' === type) {
          curEleProps.checked = $ele.is(':checked');
        }
        curEleProps.name = $ele.attr('name');
        curEleProps.widgetType = $ele.data('widget-type');
        curEleProps.value = $ele.val();
        curEleProps.dataset = $ele.data();
        curEleProps.action = $ele.data('action');
        curEleProps.cssText = $ele[0].style ? $ele[0].style.cssText : "";
        curEleProps.disabled = $ele.is(':disabled');
        curEleProps.readonly = $ele.prop('readonly'); //ORV241028 preserve readonly property
        curEleProps.title = $ele.prop('title'); //ORV241028 preserve title property
        // curEleProps.$ele = $ele;

        if (curEleProps.tagName.toLowerCase() == "select") {
          curEleProps.options = {};
          $ele.find("option").each(function (optionIndex) {
            curEleProps.options[$(this).val()] = $(this).text();
          });
        }
        return curEleProps;
      },
      restoreEleProps: function ($ele, props) {
        const type = $ele.attr('type');
        if ($ele && props) {
          if ('checkbox' === type || 'radio' === type) {
            // If this is a radio button, only set the check property if its value matches the saved value.
            if ('radio' !== type || 'radio' === type && props.value === $ele.val()) {
              $($ele).prop('checked', props.checked);
            }
          } else if ($ele.val) {
            $ele.val(props.value);
          }
        }
      },
      clearFormData: async function () {
        $(".loading-overlay").fadeIn();
        let currentlyOpenPage = this.pagesInfo.curPage;
        let availablePages = Object.keys(this.docInfo.pagesFormData);
        let maxpages = __g_pdfDoc___.numPages; //! referecing global variable here
        let pagesToOpen = [];
        let xrayContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".x-ray-content");
        //identify unpoened pages
        for (let i = 1; i <= maxpages; i++) {
          if (!availablePages.includes(i.toString())) {
            pagesToOpen.push(i);
          }
        }
        pagesToOpen.push(currentlyOpenPage);
        console.log("current page : ", this.pagesInfo.curPage);
        let clear = () => {
          //read data for all pages
          for (let pageNumber = 1; pageNumber <= maxpages; pageNumber++) {
            let formElementsForCurPage = this.docInfo.pagesFormData[pageNumber];
            if (formElementsForCurPage) {
              for (var formElementName in formElementsForCurPage) {
                if (formElementsForCurPage.hasOwnProperty(formElementName)) {
                  let formElement = formElementsForCurPage[formElementName];
                  // clear text fields
                  if (__g_zPDF_formHelper__.docInfo?.documentFormData?.[formElement.name] !== undefined) {
                    delete __g_zPDF_formHelper__.docInfo.documentFormData[formElement.name]; //ORV250127 clear documentFormData so it does not restores the data in formelements
                  }
                  if (formElement.name && formElement.name.indexOf("X_") != 0 && formElement.value && formElement.type?.toLowerCase() == "text") {
                    formElement.value = null;
                  }
                  // clear text area fields
                  if (formElement.tagName && formElement.value && formElement.tagName?.toLowerCase() == "textarea") {
                    formElement.value = null;
                  }
                  // clear Checkbox fields
                  if (formElement.name && formElement.name.indexOf("X_") != 0 && $(formElement).prop("checked") && formElement.type?.toLowerCase() == "checkbox") {
                    $(formElement).prop("checked", false);
                  }
                }
              }
            }
            // data need to be restored for every page when xray is displayed for clear
            if (!xrayContent.classList.contains("slds-hidden")) {
              this.restoreCurPageFormElements(pageNumber, this.docInfo);
            }
          }
          if (xrayContent.classList.contains("slds-hidden")) {
            this.restoreCurPageFormElements(this.pagesInfo.curPage, this.docInfo);
          }
        };
        let mainPaneRef = this.mainPane;
        let i = -1;
        let pageLoadInterval = setInterval(() => {
          if (!mainPaneRef.isPageLoading) {
            i++;
            if (i >= pagesToOpen.length) {
              clearInterval(pageLoadInterval);
              clear();
              $(".loading-overlay").fadeOut();
              return;
            }
            console.log("rendering page : " + pagesToOpen[i]);
            //  __g__allPageRotation[pagesToOpen[i]-1] gets the respective page rotation
            mainPaneRef.queueRenderPage(pagesToOpen[i], __g__allPageRotation[pagesToOpen[i] - 1]);
          }
        }, 200);
      },
      lockFields: function (ele, selectedPersona) {
        let currentPersona = getSelectedPersona(); //ORV241217 currentPersona needs to be declared - was not able to perform learn and fill
        if (!selectedPersona || selectedPersona != currentPersona) {
          //ERS241116
          //alert("Now using "+currentPersona+" instead of "+selectedPersona);
          console.log("ERS241116.894 Now using " + currentPersona + " instead of ", selectedPersona);
          selectedPersona = currentPersona;
        }
        let $this = ele;
        if (1 == 0 && selectedPersona == 'patient') {
          __g_segregatedLocks['patient'] = "Prescriber signature,Provide name,Facility name".split(",");
        }
        let disableFieldList = __g_segregatedLocks[selectedPersona] || [];
        //console.log("ERS241114.880 selectedPersona="+selectedPersona+" disables ",disableFieldList);

        if (disableFieldList.includes($this[0].name)) {
          //console.log("ERS241115 " + $this[0].name + " lockFields with "); //+disableFieldList;
          if ('signature' === $this.data('widgetType')) {
            console.log("ERS241118 " + $this[0].name + " signature disabled.");
            $this[0].title = "signature is disabled for " + selectedPersona;
            //console.log("ERS241115 ",$this[0]);
            //$this.css["background-image"}].url="/kb/images/stickynote.png";
            //$this.css({ "background-image": "url('/kb/images/stamp-redact-bg.png')" });
            $this.css({
              "background-image": "url('/r/sprz/resources/zpImages/redact-black.png')"
            });
            //background-image: url('resources/zpImages/sign_here.png');
            $this[0].disabled = true;
          } else if ($this[0].tagName === 'SELECT') {
            $this[0].disabled = true;
            $this.css({
              "background-color": "#EEFFEE"
            }); //red
          } else {
            $this.prop('readonly', true);
            //$this[0].disabled = true;
            $this.prop('disabled', true);
            $this.css({
              "background-color": "#EEFFEE"
            }); //red
            //$this.prop('background-color', "#AA0000"); //make it red
          }
        } else {
          if ('signature' === $this.data('widgetType')) {
            //console.log("ERS241115.903 ",$this);
            const eleName = $this[0].name;
            console.log("ERS241118 " + eleName + " signature enabled.");
            $this[0].title = "";
            $this[0].disabled = false;
            let imgFilePostfix = 0 === eleName.indexOf('erx-') ? "_erx" : 0 === eleName.indexOf('p11-') ? "_p11" : "";
            $this.css("background-image", `url('/r/sprz/resources/zpImages/sign_here${imgFilePostfix}.png')`);
            // $this.css({ "background-image": "url('/r/sprz/resources/zpImages/sign_here.png')" });
          } else if ($this[0].tagName === 'SELECT') {
            $this[0].disabled = false;
            $this.css({
              "background-color": ""
            });
          } else {
            $this.prop('readonly', false);
            $this.css({
              "background-color": ""
            });
            //$this.prop('background-color', ""); //make it not red
          }
        }
      },
      sigURL: null,
      sigAction: null,
      kbupPreservedValue: null,
      lockForSigningSeen: false,
      containsSignature: false,
      sendBtnSeen: false,
      doNotEverAddSendBtn: true,
      setSendToDestination(url, sendBtnNotActuallySeen) {
        // Don't let the call from inside of this component over-ride the call from pdf.js.
        //if (this.sendBtnSeen && sendBtnNotActuallySeen) {
        //    return;                 // it was already set by pdf.js
        //
        //}
        this.sigURL = url;
        this.sendBtnSeen = !sendBtnNotActuallySeen;
        //CRN211115 Find the kbup field and preserve it.
        this.kbupPreservedValue = $(this.lwcTemplate.querySelector('input[name="kbup"]')).val();
        console.log(">>> sendTo URL: " + this.sigURL);
        console.log(">>> Preserved kbup value: " + this.kbupPreservedValue);
      },
      addSendAndSignatureElementsIfNecessary: function () {
        let sendtodropDown = `<section data-annotation-id="180-Added-R" class="dropdownWidgetAnnotation"  zpaper-pdfviewermainpane_pdfviewermainpane=""
                   style="transform: matrix(1.33333, 0, 0, 1.33333, 0, 0);
                   transform-origin: -445px -25px; border-width: 0px; border-style: solid;
                   left: 453.4px; top: 32.9px; width: 120px; height: 23px;
                   zpaper-pdfviewermainpane_pdfviewermainpane="" >
                   <div class="select-editable">
                   <select onchange="this.nextElementSibling.value=this.value">
                   </select>
                   <input type="text" name="ContactFax" value="-- select an option --" class = "text" />
                   </div> </section>`;
        let sendtoBtn = `<section name="kbSubmit" data-annotation-id="188-Added-R" class="buttonWidgetAnnotation pushButton"
                    zpaper-pdfviewermainpane_pdfviewermainpane="" style="transform: matrix(1.33333, 0, 0, 1.33333, 0, 0);
                    transform-origin: -345px -25px; border-width: 1px; border-style: solid;
                    border-color: rgb(0, 0, 0); left: 353.4px; top: 32.9px; width: 90px; height: 23px;disabled:true;">
                    <input type="button" value="Send To" class ="sendtoBtn"
                        zpaper-pdfviewermainpane_pdfviewermainpane="" style="width: 100%; z-index: 9999;"></section>`;
        let $formElements = $(this.lwcTemplate.querySelector(".formContainer")).find('input');
        //CRN230322 Don't add the send button if we don't have an interactive pdf.
        //CRN230330 Correction, Eric doesn't want to ever add the Send button.
        //AHS - adding this object to avoid undefined error
        if (!this.doNotEverAddSendBtn && $formElements.length > 0 && !this.sendBtnSeen) {
          let $annotationLayer = $(__g_zPDF_formHelper__.lwcTemplate.querySelectorAll(".annotationLayer"));
          let $sendtoBtn = $(sendtoBtn);
          let $sendtodropDown = $(sendtodropDown);
          // $sendtoBtn.children('.sendtoBtn').attr('disabled',true);
          let submitURL = this.sigURL;
          $annotationLayer.append($sendtoBtn);
          $annotationLayer.append($sendtodropDown);
          $sendtodropDown.find().css('width', '118px');
          $sendtoBtn.click(function () {
            __g_zPDF_formHelper__.submitKBForm(submitURL);
          });
        } else if (this.sendBtnSeen) {
          //if the sned button is visible execute the below code, to append a dropdown
          //   let $buttonWidgetAnnotation =$annotationLayer.find('.buttonWidgetAnnotation');
          let $sendtoBtn = $(sendtoBtn);
          let $sendtodropDown = $(sendtodropDown);
          let submitURL = this.sigURL;
          $sendtoBtn.click(function () {
            __g_zPDF_formHelper__.submitKBForm(submitURL);
          });
        }
        this.getSendToOptions(getSelectedPersona());
        // Get rid "Lock to sign" if necessary.
        $('input[name="signPINhelp"]').hide();
        $('input[name="X_reviewedStatus"]').hide();
      },
      getSendToOptions: async function (selectedPersona) {
        let parentDiv = `<div class="select-editable"><select onchange="this.nextElementSibling.value=this.value"></select></div>`;
        let itemVal = [];
        let providerName = '';
        let providerNameLst = [];
        let providerFaxName = '';
        let providerEmail = '';
        let providerEmailPhone = '';
        let destinationVal = [];
        let skipEmptyRecipients;
        let ContactFax = __g_zPDF_formHelper__.lwcTemplate.querySelectorAll("input[name='ContactFax']");

        //AHS230415 - no need to generate send to options if we do not have a send to input
        if (!ContactFax || ContactFax.length == 0) {
          //no send to input available, we do not need to go any further
          return;
        }

        //AHS230415 - we have confirmed that send to input is available, only add the send to dropdown if it is not added already
        if ($(ContactFax).siblings('select').length == 0) {
          let $this = $(ContactFax);
          self.sendtotxtval = $this.val();

          //inject the div and child select
          $(parentDiv).insertBefore($this);
          $($this).css({
            "position": "absolute",
            "top": "0",
            "left": "0px",
            "width": "105px",
            "height": "22px",
            "padding": "1px",
            "font-size": "12px",
            "border": "none"
          });
          $($this).insertAfter($(".select-editable select"));
          $($this).addClass("text");
          let $section = $(".select-editable select").closest("section");
          let sectionClass = $section.attr("class").replace("textWidgetAnnotation", "dropdownWidgetAnnotation");
          $section.attr("class", sectionClass);
        }
        if (self.sendtotxtval) {
          destinationVal.push(self.sendtotxtval);
        }
        let personaData = await personaService.get(selectedPersona);
        if (personaData && personaData.wallet) {
          let fhirData = personaData.wallet.item;
          // loop over fhir data to get the destinationVal list in "INVITE:Telephone:Email" format
          for (var key in fhirData) {
            itemVal = [...itemVal, fhirData[key].item];
          }
          itemVal.forEach(medicalProvider => {
            medicalProvider.forEach(medicalProviderobj => {
              if (medicalProviderobj.text === "Name") {
                providerEmailPhone = "INVITE";
                providerName = medicalProviderobj.answer[0].valueString;
              }
              if (medicalProviderobj.text === "Fax") {
                let faxRegex = medicalProviderobj.answer[0].valueString.replace(/\D/g, '');
                if (faxRegex[0] != '1') {
                  faxRegex = "1" + faxRegex;
                }
                providerFaxName = faxRegex;
              }
              if (medicalProviderobj.text === "Email") {
                providerEmail = medicalProviderobj.answer[0].valueString;
                providerEmailPhone = providerEmailPhone + ":" + medicalProviderobj.answer[0].valueString;
              }
              if (medicalProviderobj.text === "Telephone") {
                let telephoneRegex = medicalProviderobj.answer[0].valueString.replace(/\D/g, '');
                if (telephoneRegex[0] != '1') {
                  telephoneRegex = "1" + telephoneRegex;
                }
                providerEmailPhone = providerEmailPhone + ":" + telephoneRegex;
              }

              //if(medicalProviderobj.text ==="Email"){
              //    faxNameStr  = faxNameStr+":" +medicalProviderobj.answer[0].valueString;
              //}
            });
            console.log("Debug here");
            skipEmptyRecipients = providerEmailPhone.split(/[:]/);
            if (providerName && (providerFaxName || providerEmail)) {
              destinationVal.push(providerName);
              providerNameLst.push(providerName);
            }
            if (providerName && providerFaxName) {
              destinationVal.push(providerFaxName);
            }
            if (providerName && providerEmail) {
              destinationVal.push(providerEmail);
            }
            if (providerName && skipEmptyRecipients[1] && skipEmptyRecipients[2]) {
              destinationVal.push(providerEmailPhone);
            }
          });
          // build the list of unique destinationVal
          destinationVal = [...new Set(destinationVal)];
        }
        providerNameLst.push("Other");
        destinationVal.push("Other");
        destinationVal.push("PDF");
        let $sendToDropdownSelect = $(this.lwcTemplate.querySelectorAll('.dropdownWidgetAnnotation select'));
        let $sendToDropdowntext = $(this.lwcTemplate.querySelectorAll('.dropdownWidgetAnnotation input'));
        let $sendtoBtn = $(this.lwcTemplate.querySelectorAll('.buttonWidgetAnnotation input'));
        //clear out existing values
        $sendToDropdownSelect.empty();
        let $optionToAdd = $("<option>" + "-- select an option --" + "</option>", {
          value: "none"
        });
        $sendToDropdownSelect.append($optionToAdd);
        for (let i = 0; i < destinationVal.length; i++) {
          if (destinationVal[i] != '') {
            //build the new option element to add
            $optionToAdd = $("<option>" + destinationVal[i] + "</option>", {
              value: destinationVal[i]
            });
            if (providerNameLst.includes(destinationVal[i]) && $optionToAdd.val() != "PDF") {
              $optionToAdd.attr('disabled', true);
              $optionToAdd.css('background-color', 'yellow');
            }
            //apped the option to the select element
            $sendToDropdownSelect.append($optionToAdd);
          }
        }
        $sendToDropdownSelect.change(function () {
          if ($sendToDropdownSelect.val() == '-- select an option --' || $sendToDropdownSelect.val() == null || $sendToDropdownSelect.val() == '') {
            $sendtoBtn.attr('disabled', true);
          } else {
            $sendtoBtn.attr('disabled', false);
          }
          // sendToDropdowntext on change event
          $sendToDropdowntext.change(function () {
            //!check how many times this is executed
            console.log("in change if required" + $sendToDropdowntext.val());
          });
        });
      },
      submitKBForm: function (action, sendCurrentDocument) {
        addTimestamp("start submitKBForm");
        const queryParams = new URLSearchParams(window.location.search);
        // Supporting Eric's "Classic" button. Clicking that button will set the __g_isApiServerAvailable to false.
        // CRN230324 if !__g_isApiServerAvailable, we should use the URL specified in the pdf, if it has been set.
        if (!window.__g_isApiServerAvailable) {
          action = this.sigURL ? this.sigURL : "/kb/jsp/SF_sendFax.jsp";
        }
        // else if (window.__g_jobsURL) { action = window.__g_jobsURL; }//AHS230313 - fixing jobs endpoint
        if (window.__g_jobsURL) {
          action = window.__g_jobsURL;
        } //AHS231201 - else was changed to if becuase we had a problem with jobsurl. Setting the value on the global variable did not take any effect. This is being done during the changes for submit (Post to google)

        var emailPattern = /^([^@]+@[^@]+\.[^@]+|PDF)$/i; // from https://stackoverflow.com/a/50343015
        let invalidDest = false;
        let _self = this; //declaring & assigning value to _self
        let $form = $(_self.lwcTemplate.querySelector(".formContainer"));
        this.destination = null;
        // get mail destination dropdown values in $sendToDropdownSelect
        let $sendToDropdownSelect = $(this.lwcTemplate.querySelectorAll('.dropdownWidgetAnnotation select'));
        let $sendToDropdowntext = $(this.lwcTemplate.querySelectorAll('.dropdownWidgetAnnotation input'));
        _self.destination = $sendToDropdowntext.val();
        let faxNumber = $sendToDropdowntext.val();
        if (invalidDest) {
          return false; // Don't submit or create an activity
        }

        // Finally, add any captured signature data.
        //let $sigImageCount = parseInt($("#sigImageCount").val(), 10);
        let $sigImageCount = this.__sigHelper.sigImageCount;
        if ($sigImageCount > 0) {
          let $sigForm = $("#sigImgInfoForm");
          $('<input>').attr({
            type: 'hidden',
            name: 'X_sigImageCount',
            value: $sigImageCount
          }).appendTo($form);
          // For backwards compatibility, I'll continue to send one long X_markup string.
          let buffer = "";
        }
        $form.attr('action', action + "?zPaper=1220");
        let htmlFormData = new FormData($form.get(0)); //post to zippi expects a HTMLFormElement

        // Restore any form input elements from pages that aren't currently being viewed.
        // this.addViewedFormElements(this.pagesInfo.curPage, htmlFormData);

        //CRN250118 Add any Part 11/eRx signature data.
        this.addESigDataToFormSubmission(htmlFormData);

        //append attach panel data -start
        const docTypeRegex = /docType(\d+)/;
        const templateRegex = /template(\d+)/;
        for (let pair of __g_zPDF_formHelper__.attachmentFormData.entries()) {
          // Check for images here and create pdf page holding the image and maybe also submit the image like we do signature images?
          let name = pair[0];
          let value = pair[1];

          // if (docTypeRegex.test(name) && "Image" === value) { value = "image/png"; }
          // If this a captured photo, we don't have a file object, just send the image data.
          if (templateRegex.test(name) && typeof value === 'string') {
            value = JSON.parse(value).imgData;
            const b64Data = value.substring("data:image/png;base64,".length);
            const contentType = "image/png";
            value = b64toBlob(b64Data, contentType); // The blob will be submitted just like a file.
            htmlFormData.append(name, value, name + ".png");
          } else {
            htmlFormData.append(name, value);
          }
        }
        if (__g_zPDF_formHelper__.localFile) {
          // No need to add the local file because postMultiPartForm will always send along the currently-viewed pdf.
          // If we have a localFile, we also have the kbup field preserved. Add it back.
          htmlFormData.append("kbup", __g_zPDF_formHelper__.kbupPreservedValue);
        }
        htmlFormData.append("zPaper", "1220");
        // htmlFormData.append("flattenPdf", "true");

        addTimestamp("now calling postMultiPartForm");
        // _self.fetch(action + "?zPaper=1220", "POST", htmlFormData, (data, textStatus, jqXHR) => {
        _self.postMultiPartForm(action, "POST", htmlFormData, (data, textStatus, jqXHR) => {
          addTimestamp("postMultiPartForm callback start (s)");
          window.__g_newItem = data; //SHR251107: #121671 - preserve the newly created zItem

          if (!_self.destination || _self.destination !== 'PDF' && _self.destination.indexOf('@') < 0) {
            // If the destination isn't  PDF or an email, just return since we don't show previews of fax sends.
            return;
          } else if (!isApiServerAvailable) {
            //thos will run if api server is not available
            setTimeout(() => {
              try {
                let win = window.open("", "_new", 'width=' + screen.availWidth + ',height=' + screen.availHeight);
                if (!win) {
                  let warningToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".warning-notification"));
                  let warningToastText = $(warningToast).find(".warning-text");
                  $(warningToastText).html("Your pop-up blocker is keeping us from showing your document. " + "Please allow the pop-up window.");
                  $(warningToast).removeClass("slds-hidden");
                  setTimeout(() => {
                    $(warningToast).addClass("slds-hidden");
                  }, 4000);
                  return;
                }
                win.document.write(data);
                win.document.close();
              } catch (err) {
                console.log(err);
              }
            }, 250);
            return;
          }

          // we will perform the below code if api server is available
          //AHS230316 - added showFile function to open PDF in new tab
          let showFile = function (blob) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([blob], {
              type: "application/pdf"
            });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return;
            }
            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            let newWindow = window.open(data, "_blank", 'width=' + screen.availWidth * 0.8 + ',height=' + screen.availHeight * 0.8);
          };
          let url = __g_zApiURL + 'viewForm/' + data.id;
          //AHS230316 - updating the logic for view form - added start
          addTimestamp("now redownloading the sent pdf");
          let statusCheck;
          fetch(url).then(response => {
            if (response.status == 200) {
              response.blob().then(response => {
                addTimestamp("pdf downloaded");
                showFile(response);
                addTimestamp("pdf opened in a new tab");
              });
            }
          });
          //AHS230316 - updating the logic for view form - added end
        }, (jqXHR, textStatus, errorThrown) => {
          window.__g_newItem = null; //SHR251107: #121671 - no zItem created, reset the global
          console.error("Error calling postMultipartForm: ", textStatus, " - ", errorThrown);
        }, sendCurrentDocument, false); //ERS250124 #115517 TODO look for other clues
        // }, this.localFile || queryParams.get('f') ? true : false, false);   // If we have loaded a pdf of if there is an 'f' parameter, make sure we post it instead of just a Snippet Id.
        addTimestamp("the end");
        return false;
      },
      postMultiPartForm: function (url, method, data, successFunction, errorFunction, sendCurrentDocument, flattenForm, doNotEnforceRequiredFields) {
        if (!sendCurrentDocument) {
          //
          if (__g_zPDF_signatureHelper__.markupImageList.length > 0) {
            let buffer = "";
            let imgCount = 1;
            __g_zPDF_signatureHelper__.markupImageList.forEach(imgData => {
              //m(id,n,src,w,h,x,y,val)
              //kbm('IMG1','PAGE1IMG1','https://emr2.knowledgebin.com/kb/views/ipad/oval.gif',157,29,186,98,'');
              //kbm('IMG4','PAGE1IMG4','addText',15,1,73,150,'test%2012%203');
              // return "kbm('" + id + (id.indexOf("_REALPDFCOORDS") < 0 ? "_REALPDFCOORDS" : "") + "','" +
              //     n + "','" + src + "'," + w + "," + h + "," + x + "," + y + ",'" +
              //     val + "','" + font + "',"  + pdfW + "," + pdfH + "," + pdfX + "," + pdfY + ");\n";
              const source = "TEXTAREA" === imgData.image.tagName ? "addText" : "IMG" === imgData.image.tagName ? imgData.image.src : imgData.image.toDataURL();
              const id = imgData.id + "_REALPDFCOORDS";
              //Note: font information (other than font size) isn't really supported in either kb or zippi.
              // We'll need to add support for family, bold, and italic if we need it.
              const fontSize = imgData.fontSize;
              const value = "TEXTAREA" === imgData.image.tagName ? imgData.image.value : '';
              const [x1, y1, x2, y2] = imgData.pdfCoords;
              buffer += `kbm('${id}','PAGE${imgData.page}IMG${imgCount++}','${source}',${Math.round(imgData.screenWidth)}` + `,${Math.round(imgData.screenHeight)},${Math.round(imgData.screenX)},${Math.round(imgData.screenY)},'${value}'` + `,${Math.round(imgData.fontSize)},${Math.round(x2 - x1)},${Math.round(y2 - y1)},${Math.round(x1)},${Math.round(y1)});\n`;
            });
            data.append("X_markup", buffer);
          }
        }
        // Send along whatever pdf is currently being viewed.
        const eventService = {
          fireEvent: fireEvent,
          registerListener: registerListenerAndTrack,
          unregisterListener: unregisterListener,
          eventTypes: eventTypes,
          pageRef: {
            attributes: {
              "developer": "zPaper",
              "application": "Document Viewer"
            }
          }
        };
        // Anything calling this function will get all of the pages (passing null for the pageRange parameter).
        prepPdfForSubmission(__g_pdfDoc___, __g_zPDF_formHelper__, __g_zPDF_signatureHelper__, __g_zPDF_signatureHelper__.markupImageList, eventService, null, flattenForm, !sendCurrentDocument, doNotEnforceRequiredFields).then(pdfBlob => {
          //CRN250317 Fill the form that will be submitted from documentFormData so that we don't have to physically flip through the pages.
          // The call to prepPdfForSubmission() will have filled documentFormData.
          __g_zPDF_formHelper__.addAllFormElements(data);
          // Make sure it is always first in any list of templates.
          if (!sendCurrentDocument) {
            data.append("template0", __g_templateId);
          } else {
            console.log("Submitting Blob of size: ", pdfBlob.size);
            data.append("template0", pdfBlob, "template0.pdf");
          }
          $(".loading-overlay").fadeIn();
          let SFserver = "https://spar-demo-zp02.lightning.force.com/";
          //AHS230124 - adding sf auth headers here
          let headers = {
            "Access-Control-Allow-Origin": "*",
            "Accept": "application/json"
            // "Authorization": "00D4W000002V5fg!ARcAQCG1bSlTNKt9svr9Xw1kh_zKReAR_0rT.pI39cEW8tRwpKxrhckdbhokuCbyoE9JyTUWd.qfpI8p9SBc_vmkPheXrJPH",
            // "x-api-user": "cory.newey@zpaper.com.devthree",
            // "X-API-Key": "tIAOt1Z6078GiHt7ArXoF/eVefS1tl2bJiwB6O5GLIwsNCbfTH4IyuCjyEBSNqrj"
          };
          headers = _objectSpread(_objectSpread({}, getDefaultHeaders()), headers);
          let _self = this;
          $.ajax({
            type: method,
            enctype: 'multipart/form-data',
            //enctype: 'application/x-www-form-urlencoded',
            url: url,
            // url: "/zippi/jobs",
            data: data,
            processData: false,
            contentType: false,
            cache: false,
            timeout: 600000,
            headers: headers,
            success: function (data, textStatus, jqXHR) {
              console.log("successfully executed");
              console.log("data", data);
              console.log("textStatus", textStatus);
              console.log("jqXHR", jqXHR);
              $(".loading-overlay").fadeOut();
              if (successFunction) {
                try {
                  successFunction(data, textStatus, jqXHR);
                } catch (err) {
                  if (_self.destination === "PDF") {
                    let errorToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".error-notification"));
                    let errorToastText = $(errorToast).find(".error-text");
                    $(errorToastText).html("There has been an error while generating the preview");
                    $(errorToast).removeClass("slds-hidden");
                    setTimeout(() => {
                      $(errorToast).addClass("slds-hidden");
                    }, 3000);
                  }
                }
              }
              let successToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".success-notification"));
              let successToastText = $(successToast).find(".success-text");
              $(successToastText).html("Processed successfully");
              $(successToast).removeClass("slds-hidden");
              setTimeout(() => {
                $(successToast).addClass("slds-hidden");
              }, 3000);
            },
            error: function (jqXHR, textStatus, errorThrown) {
              $(".loading-overlay").fadeOut();
              console.log("execution failed");
              console.log("jqXHR", jqXHR);
              console.log("textStatus", textStatus);
              console.log("errorThrown", errorThrown);
              if (errorFunction) {
                errorFunction(jqXHR, textStatus, errorThrown);
              }
              let errorToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".error-notification"));
              let errorToastText = $(errorToast).find(".error-text");
              $(errorToastText).html("There has been an error while processing the document");
              $(errorToast).removeClass("slds-hidden");
              setTimeout(() => {
                $(errorToast).addClass("slds-hidden");
              }, 3000);
            }
          });
        }).catch(err => console.log(`This error should've already been handled: ${err}`));
      }
    };
    /*
    this.__g_zPDF_formHelper__ = new __formHelper();
    window.__g_zPDF_formHelper__ = this.__g_zPDF_formHelper__;
    window.__g_zPDF_formHelper__.pagesInfo = this.__pageInfo___;
    window.__g_zPDF_formHelper__.docInfo = this.__docInfo___;
    window.__g_zPDF_formHelper__.lwcTemplate = this.template;
    //window.__g_zPDF_formHelper__.lwcComponent = this;
    */

    // make this global so that pdf.js functions can call us
    //let __sigHelper = function() { };
    this.__sigHelper.prototype = {
      // lockedForSigning: false,
      //oldBGColor: "lightblue",
      oldBGColor: "rgba(0, 54, 255, 0.13)",
      //updated oldBGColor was not lightblue, updated it to match
      $curEle: null,
      $curEleParent: null,
      signerPad: null,
      notInvited: false,
      //ERS210119 #77302 support templates and markup use cases
      signatoryNumber: -1,
      pagesInfo: null,
      sigImageCount: 0,
      sigImageList: [],
      markupImageList: [],
      lwcTemplate: null,
      lwcComponent: null,
      /**
       * @author ORV240110
       * reinitializePrototype resets all the variables when pdf is loaded.
       * @memberof __sigHelper
       * @function
       * @name reinitializePrototype
       *
       * @example
      * __sigHelper.reinitializePrototype();
      */
      reinitializePrototype: function () {
        this.oldBGColor = "rgba(0, 54, 255, 0.13)";
        this.$curEle = null;
        this.$curEleParent = null;
        this.signerPad = null;
        this.notInvited = false;
        this.signatoryNumber = -1;
        this.pagesInfo = null;
        this.sigImageCount = 0;
        this.sigImageList = [];
        this.markupImageList = [];
        this.lwcTemplate = null;
        this.lwcComponent = null;
      },
      agreedToSign: function () {
        $(this.lwcComponent.__$lockConfirmationDialog).dialog("close");
        window.localStorage.setItem("agreedToSign", "true");
        let eleName = $(this.lwcComponent.__$lockConfirmationDialog).data("eleNameParameter");
        let ele = $(this.lwcComponent.__$lockConfirmationDialog).data("eleParameter");
        let callback = $(this.lwcComponent.__$lockConfirmationDialog).data("callbackParameter");
        const callbackOptions = $(this.lwcComponent.__$lockConfirmationDialog).data("callbackOptions");
        // this.prepareToSign();//re-enter the prepareToSign method once user has agreed to Electronic Record and Signature Disclosure
        this.captureSigImproved(callbackOptions); //re-enter the captureSig method once user has agreed to Electronic Record and Signature Disclosure
        // this.captureSig(eleName, ele, callback);//re-enter the captureSig method once user has agreed to Electronic Record and Signature Disclosure
      },
      prepareToSign: function () {
        let hasAgreedToSign = window.localStorage.getItem("agreedToSign");
        if (hasAgreedToSign !== "true") {
          $(this.lwcComponent.__$lockConfirmationDialog).dialog("open");
          if (this.isMobile()) {
            __fixMobileDialogStyle($('.ui-dialog'));
          }
          return; //exit the method after opening the pop
        }
        // this.lockedForSigning = true;
        let parent = this;
        let _this = this;
        this.lwcTemplate.querySelectorAll('.sigWidgetAnnotation').forEach(ele => {
          let $this = $(ele);
          let signName = "inviteSign" + _this.signatoryNumber;
          // We might already have a signature here since the restore call will be made before this.
          // Handle that case.
          if (!$this.children('img')) {
            // This won't be truthy if there is already a signature captured.
            $this.children('input').each(function (j) {
              let $this = $(this);
              $this.removeAttr('disabled');
              // set the css style directly instead of calling show(). The second time that show is called,
              // it sets the display style to be 'inline' which seems to keep the button from being clickable
              // $this.show();
              $this.css('display', 'block');
            });
          }
        });
      },
      eleContainsSigImage: function ($ele) {
        let $children = $ele.children();
        for (let i = 0; i < $children.length; i++) {
          if ($($children[i]).hasClass('signatureImage')) {
            return true;
          }
        }
        return false;
      },
      exitSigning: function () {
        // this.lockedForSigning = false;
        let parent = this;
      },
      getTextHeight: function (font, size) {
        // Note: this function will no longer when all browsers finally support advanced text metrics.
        let text = $('<span>Hg</span>').css({
          fontFamily: font,
          fontSize: size + "px"
        });
        let block = $('<div style="display:inline-block;width:1px;height:0px;"></div>');
        let div = $('<div></div>');
        div.append(text, block);
        let body = $('body');
        body.append(div);
        let result = {};
        try {
          block.css({
            verticalAlign: 'baseline'
          });
          result.ascent = block.offset().top - text.offset().top;
          block.css({
            verticalAlign: 'bottom'
          });
          result.height = block.offset().top - text.offset().top;
          result.descent = result.height - result.ascent;
        } finally {
          div.remove();
        }
        return result;
      },
      stampImage(canvas, imgUrl) {
        return new Promise((resolve, reject) => {
          const ctx = canvas.getContext("2d");
          const canvasWidth = canvas.clientWidth;
          const canvasHeight = canvas.clientHeight;
          ctx.clearRect(0, 0, canvasWidth, canvasHeight);
          const image = new Image();
          image.onload = () => {
            ctx.drawImage(image, 0, 0, canvasWidth, canvasHeight);
            resolve();
          };
          image.onerror = error => {
            reject(error);
          };
          image.crossOrigin = 'anonymous';
          image.src = imgUrl;
        });
      },
      stampTypedSignatureInCanvas(canvas, typedSignature, fontInfoStr) {
        let fontInfo = fontInfoStr.split(':');
        let fontFamily = fontInfo[0];
        let fontSize = fontInfo[1];
        let ctx = canvas.getContext("2d");
        let canvasWidth = canvas.clientWidth;
        let canvasHeight = canvas.clientHeight;
        let textHeightInfo = this.getTextHeight(fontFamily, fontSize);
        ctx.fillStyle = "blue";
        ctx.font = fontSize * 1.5 + "px " + fontFamily;
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillText(typedSignature, 10, canvasHeight / 2 + textHeightInfo.height / 2 - 10, canvasWidth - 20);
        let imgData = canvas.toDataURL();
        window.localStorage.setItem('zPaperSigImage', imgData);
      },
      promptForTypedSignature: function ($promptDialogDiv, destinationCanvas, curSignatureData) {
        return new Promise((resolve, reject) => {
          const self = this;
          // let _oldSigData = '';
          let _oldTypedSigFontData = '';
          let _oldNameText = '';
          try {
            _oldTypedSigFontData = window.localStorage.getItem('zPaperTypedSigFontData');
            // _oldSigData = window.localStorage.getItem('zPaperSigData');
            // _oldSigData = JSON.parse(_oldSigData);
            _oldNameText = window.localStorage.getItem('zPaperSigText');
          } catch (e) {
            console.error("Exception pulling signature data from localStorage: " + e);
          }
          const $sigTextField = $promptDialogDiv.find('.typeSignatureText');
          const $sigFontSelect = $promptDialogDiv.find('.fontFamilySelect');
          $sigFontSelect.off('change');
          if (_oldTypedSigFontData) {
            // select the same font as the signature that has already been captured
            $sigFontSelect.val(_oldTypedSigFontData);
            const fontInfo = _oldTypedSigFontData.split(':');
            $sigTextField.css('font-family', fontInfo[0]);
            $sigTextField.css('font-size', fontInfo[1] + 'px');
          }
          $sigFontSelect.change(function () {
            const fontInfoStr = $(this).val();
            const fontInfo = fontInfoStr.split(':');
            $sigTextField.css('font-family', fontInfo[0]);
            $sigTextField.css('font-size', fontInfo[1] + 'px');
          });
          if (curSignatureData && curSignatureData.fullName) {
            $sigTextField.val(curSignatureData.fullName);
          } else if (_oldNameText) {
            $sigTextField.val(_oldNameText);
          }
          let $typeSignatureDlg = $promptDialogDiv.dialog({
            width: self.isMobile() ? 400 : 610,
            height: 254,
            resizable: false,
            title: "Enter Full Name",
            buttons: {
              "Ok": function () {
                let typedSignature = $sigTextField.val();
                if (typedSignature) {
                  if (curSignatureData) {
                    curSignatureData.fullName = typedSignature;
                  }
                  window.localStorage.setItem('zPaperTypedSigFontData', $sigFontSelect.val());
                  window.localStorage.setItem('zPaperSigText', typedSignature);
                  self.stampTypedSignatureInCanvas(destinationCanvas, typedSignature, $sigFontSelect.val());
                }
                $typeSignatureDlg.dialog("close");
                resolve(curSignatureData);
              },
              Cancel: function () {
                $typeSignatureDlg.dialog("close");
                resolve(curSignatureData);
              }
            }
          });
        });
      },
      isMobile: function () {
        return window.__g_isMobile;
      },
      captureSig: function (eleName, ele, callback) {
        this.captureSigImproved({
          "eleName": eleName,
          "ele": ele,
          "callback": callback
        });
      },
      captureSigImproved: function (options) {
        const {
          eleName,
          ele,
          callback,
          part11
        } = options;

        // Hide the eRx Prescription Dialog if necessary
        __eRxPrescriptionDialog(false);

        // Don't use the name attribute any more because there could be multiple signature fields that have the same name.
        if (ele) {
          // Supporting external call from Markup toolbar. We won't need $curEleParent if called from markup.
          this.$curEle = $(ele);
          ele.scrollIntoView();
          this.$curEleParent = this.$curEle.parent();
        }

        // var erxFrame = $("<iframe src='https://zen.qr.md/r/emr/erx/' id='erxFrame' width='100%' width0=350 height='100%' frameBorder='0'></iframe>");
        if (0 === eleName?.indexOf("erx-")) {
          __eRxPrescriptionDialog(true);
          return;
        }

        // temporary work-around to get the x-ray out of the way (will be restored when signature is done)
        // $(this.lwcTemplate.querySelector('.x-ray-content')).css('display', 'none');
        let hasAgreedToSign = window.localStorage.getItem("agreedToSign");
        // if(hasAgreedToSign !== "true" || part11) {          // for now, always prompt for esig exception when doing part11 esigs
        if (hasAgreedToSign !== "true") {
          // for now, always prompt for esig exception when doing part11 esigs
          $(this.lwcComponent.__$lockConfirmationDialog).data("eleNameParameter", eleName);
          $(this.lwcComponent.__$lockConfirmationDialog).data("eleParameter", ele);
          $(this.lwcComponent.__$lockConfirmationDialog).data("callbackParameter", callback);
          $(this.lwcComponent.__$lockConfirmationDialog).data("callbackOptions", options);
          $(this.lwcComponent.__$lockConfirmationDialog).dialog("open");
          if (this.isMobile()) {
            __fixMobileDialogStyle($('.ui-dialog'));
          }
          return; //exit the method after opening the pop
        }
        if (!this.$drawingDIV) {
          this.sigCanvas = this.lwcTemplate.querySelector('.pad');
          this.$drawingDIV = $(this.lwcTemplate.querySelector('.sigDrawingDIV'));
          this.$sigPadForm = $(this.lwcTemplate.querySelector('.sigPadForm'));
          this.$sigNameEle = $(this.lwcTemplate.querySelector('.clearTextName'));
          this.$sigDateEle = $(this.lwcTemplate.querySelector('.signatureDate'));
          this.$saveSigForSigning = $(this.lwcTemplate.querySelector('.saveForDocSigning'));
          this.$typedSignatureDialogDIV = $(this.lwcTemplate.querySelector('.sigTypeSignatureDIV'));
        }
        __promptForMobileSignature(this, callback, part11);
      },
      parseNumber(number) {
        if (!(typeof number === 'string')) {
          return number;
        }
        if (!number) {
          return 0;
        }
        if (number.indexOf('px') >= 0) {
          number = number.substring(0, number.indexOf('px'));
        }
        return parseInt(number, 10);
      },
      restoreDocumentWindow: function () {
        this.$drawingDlg.dialog('close');
        // let $drawingDIV = $(this.lwcTemplate.querySelector('.sigDrawingDIV'));
        // $drawingDIV.slideToggle({}, 300);
        // Restore the document window height.
        // this.lwcComponent.__$containerDiv.css('height', '97vh');
        // restoration step of temporary workaround that gets x-ray out of signature way
        // $(this.lwcTemplate.querySelector('.x-ray-content')).css('display', 'flex');
      },
      clearSignature: function () {
        this.signerPad.clearCanvas();
        window.localStorage.removeItem('zPaperTypedSigFontData');
        // window.localStorage.removeItem('zPaperSigData');
        window.localStorage.removeItem('zPaperSigText');
      },
      signIt: function (esigData, callback) {
        return new Promise((resolve, reject) => {
          let timeStamp = new Date().getTime();
          if (this.$curEle) {
            this.$curEle.addClass('signatureComplete');
            this.$curEle.hide();
          }
          let sigDate = new Date().toLocaleDateString(); //this.$sigDateEle.val();
          let canvasRect = this.sigCanvas.getBoundingClientRect();
          let _self = this;
          // Save the image data of just the pure signature, before stamping with name and date.
          const pureImgData = this.sigCanvas.toDataURL();
          window.localStorage.setItem('zPaperSigImage', pureImgData);
          setTimeout(function () {
            // Supporting external call from new Markup Toolbar...
            if (callback) {
              if (!esigData) {
                esigData = {};
              }
              esigData.sigImageData = _self.sigCanvas.toDataURL();
              callback(esigData);
              resolve();
              return;
            }
            let imgElement = $('<img />');
            window.console.log("@@@ pureImgData = " + pureImgData);
            imgElement.addClass('signatureImage');
            // Crop out the surrounding whitespace.
            const croppedImgData = _self.getWhiteSpaceCroppedImageData(_self.sigCanvas);
            imgElement.attr('src', croppedImgData.url);
            imgElement.attr('id', "IMG" + timeStamp);
            imgElement.css('display', "none");

            // pull its dimensions before resizing
            let originalImgWidth = croppedImgData.width;
            let originalImgHeight = croppedImgData.height;
            // now remove it and add the correctly-sized one
            _self.$curEleParent.remove('#IMG' + timeStamp);
            window.console.log("@@@ original image dimensions: width = " + originalImgWidth + ", height = " + originalImgHeight);
            // finally, add it again with proper dimensions
            if (_self.$curEle.data('xray')) {
              let formElementData = _self.$curEle.data('formElement');
              // Save signature data for application to pdf/xray view as needed.
              // formElementData.sigData = sigData;
              formElementData.src = pureImgData;
              // If we are in xray mode, just return here. The signature data was already saved in the sigHelper
              // for application to the pdf view.
              imgElement.css('display', "");
              _self.$curEleParent.append(imgElement);
              resolve();
              return;
            }
            // clear out any old signatures, after getting the index of current signature
            let curImageIndex = -1;
            _self.$curEleParent.children('img').each(function () {
              curImageIndex = $(this).data('sigImageCount');
            });
            _self.$curEleParent.children('img').remove();
            _self.$curEleParent.append(imgElement);
            imgElement.css('display', "block");
            // Tweak the parent top since the transform pushes the signature down too far.
            const curTop = _self.parseNumber(_self.$curEleParent.css('top'));
            const curHeight = _self.parseNumber(_self.$curEleParent.css('height'));
            if (curHeight && curTop) {
              // Since we are no longer stamping the clear-text name and date at the bottom of the signature stamp,
              // move it up another 10 pixels.
              _self.$curEleParent.css('top', curTop - curHeight / 2 - 10 + "px");
              imgElement.css('height', curHeight * 2 + "px");
            }
            if (_self.isMobile()) {
              //CRN230408 Tweak mobile coordinates a bit more.
              let curParentTop = _self.parseNumber(_self.$curEleParent.css('top'));
              _self.$curEleParent.css('top', curParentTop - 6 + "px");
            }
            setTimeout(function () {
              _self.addSignatureToForm({
                "imgElement": imgElement,
                "curImageIndex": curImageIndex,
                "sigData": sigDate,
                "url": croppedImgData.url,
                "width": croppedImgData.width,
                "height": croppedImgData.height
              });
              $('#pleaseSignHereAnchor').hide();

              // If there are no more signature prompts on this page, move forward if we can.
              let signingThisPageComplete = true;
              let signName = "inviteSign" + _self.signatoryNumber;
              $('[name = "' + signName + '"]').each(function () {
                if (!$(this).hasClass('signatureComplete')) {
                  signingThisPageComplete = false;
                }
              });
              resolve();
            }, 150);
          }, 100);
        });
      },
      handlingSignatureEvent: false,
      addSignatureToForm: function (options) {
        const {
          imgElement,
          curImageIndex,
          sigDate,
          left,
          top,
          width,
          height,
          url,
          isP11Sig
        } = options;
        const signatureFieldName = this.$curEle.attr('name');
        const imgBoundingRect = imgElement[0].getBoundingClientRect();
        const parentBoundingRect = this.$curEleParent ? this.$curEleParent[0].getBoundingClientRect() : null;
        // let resizedImgWidth = width ? width : this.parseNumber(imgElement.css('width'));
        // let resizedImgHeight = height ? height: this.parseNumber(imgElement.css('height'));
        let resizedImgWidth = !isP11Sig ? imgBoundingRect.width : width ? width : this.parseNumber(imgElement.css('width'));
        let resizedImgHeight = !isP11Sig ? imgBoundingRect.height : height ? height : this.parseNumber(imgElement.css('height'));
        window.console.log("@@@ resized image dimensions: width = " + resizedImgWidth + ", height = " + resizedImgHeight);
        // <input type="hidden" id="X_markup" name="X_markup" />
        // <input type="hidden" id="X_sigImage" name="X_sigImage" />
        // <input type="hidden" id="X_sigSizing" name="X_sigSizing" />
        let $sigForm = $(this.lwcTemplate.querySelector(".formContainer"));
        let currentSigIndex = curImageIndex && curImageIndex >= 0 ? curImageIndex : this.sigImageCount;
        imgElement.data("sigImageCount", currentSigIndex);
        let $sigImage = $('#sigImg_IMG' + currentSigIndex);
        let $sigSizing = $('#sigSizing_IMG' + currentSigIndex);
        let $sigMarkup = $('#sigMarkup_IMG' + currentSigIndex);
        if (0 === $sigImage.length) {
          // new signature, create fields for it
          $sigImage = $('<input>').attr({
            type: 'hidden',
            id: 'sigImg_IMG' + currentSigIndex,
            name: 'X_sigImage_' + signatureFieldName
          }).appendTo($sigForm);
          $sigSizing = $('<input>').attr({
            type: 'hidden',
            id: 'sigSizing_IMG' + currentSigIndex,
            name: 'X_sigSizing_' + signatureFieldName
          }).appendTo($sigForm);
          $sigMarkup = $('<input>').attr({
            type: 'hidden',
            id: 'sigMarkup_IMG' + currentSigIndex,
            name: 'X_markup_' + signatureFieldName
          }).appendTo($sigForm);
          $('<input>').attr({
            type: 'hidden',
            name: 'X_signerDate_' + signatureFieldName,
            value: sigDate
          }).appendTo($sigForm);
          $('<input>').attr({
            type: 'hidden',
            name: 'X_signedFormElement_' + signatureFieldName,
            value: 'true'
          }).appendTo($sigForm);
          $('<input>').attr({
            type: 'hidden',
            name: 'X_signedPdfField_' + signatureFieldName,
            value: `'${this.$curEleParent.data('annotation-id')}'`
          }).appendTo($sigForm);
        }
        $sigImage.val(url);
        $sigSizing.val(resizedImgWidth / width + "," + resizedImgHeight / height);
        const screenWidth = resizedImgWidth;
        const screenHeight = resizedImgHeight;
        const matrixTransform = this.$curEleParent.css('transform');
        const matrixRegex = /matrix\((\d+\.?\d*), \d+\.?\d*, \d+\.?\d*, (\d+\.?\d*),/;
        const matrixMatch = matrixTransform ? matrixTransform.match(matrixRegex) : null;
        const scaleX = matrixMatch ? parseFloat(matrixMatch[1]) : 1;
        const scaleY = matrixMatch ? parseFloat(matrixMatch[2]) : 1;
        const screenX = Math.floor(left ? left : this.parseNumber(this.$curEleParent.css('left')) * scaleX);
        const screenY = Math.floor(top ? top : this.parseNumber(this.$curEleParent.css('top')) * scaleY);
        const pdfPageCoords = getPdfCoordinates(window.__g_zPDF_signatureHelper__.pagesInfo.curPageView, screenX, screenY, screenWidth, screenHeight);
        const pdfWidth = Math.floor(Math.abs(pdfPageCoords[0] - pdfPageCoords[2]));
        const pdfHeight = Math.floor(Math.abs(pdfPageCoords[1] - pdfPageCoords[3]));
        pdfPageCoords[0] -= 72 / 9; //CRN250426 we're a little to far right. Maybe same border reason as y coordinate? Tweak it.
        pdfPageCoords[2] -= 72 / 9;
        pdfPageCoords[1] -= 72 / 14; //CRN250426 We're a little too high. Maybe its because there is not border above the document in the browser? I don't know but lets tweak it.
        pdfPageCoords[3] -= 72 / 14;
        const pdfX = Math.floor(pdfPageCoords[0]);
        const pdfY = Math.floor(pdfPageCoords[1]);
        this.sigImageList.push({
          id: 'stampSig_' + this.sigImageCount,
          name: signatureFieldName,
          page: this.pagesInfo.curPage,
          image: imgElement[0],
          divParent: this.$curEleParent,
          pdfCoords: pdfPageCoords,
          screenX: screenX,
          screenY: screenY,
          screenWidth: screenWidth,
          screenHeight: screenHeight,
          fontSize: 12,
          fontFamily: "Helvetica",
          fontColor: "rgb(0, 0, 0)",
          fontBold: false,
          fontItalic: false,
          isP11Sig: isP11Sig
        });
        $sigMarkup.val("kbm('" + imgElement.attr('id') + "_REALPDFCOORDS','PAGE" + this.pagesInfo.curPage + imgElement.attr('id') + "','" + url + "'," + Math.floor(screenWidth) + "," + Math.floor(screenHeight) + "," + Math.floor(screenX) + "," + Math.floor(screenY) + ",'',''," + pdfWidth + "," + pdfHeight + "," + pdfX + "," + pdfY + ");");

        // increment the count if we aren't using a previously-used count
        if (curImageIndex < 0) {
          this.sigImageCount++;
        }

        // meetNow sharing
        if (window.shareSignature && !this.handlingSignatureEvent) {
          window.shareSignature(this.sigImageList, __g_zPDF_formHelper__, imgElement[0]);
        }
        this.handlingSignatureEvent = false;
        return `X_sigImage_${signatureFieldName}`;
      },
      findSignatureElement: function (name) {
        const xrayContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".x-ray-content");
        const mainPaneContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".main-pane-content");
        let $form;

        //if main pane is not hidden, learn from main pane
        if (!mainPaneContent.classList.contains("slds-hidden")) {
          $form = $(mainPaneContent);
        }
        //if x-ray is not hidden, do not learn from x-ray
        else if (!xrayContent.classList.contains("slds-hidden")) {
          $form = $(xrayContent);
        }
        let eleList = $form.find('[data-widget-type="signature"]');
        if (eleList.length > 0) {
          eleList = eleList.filter((idx, ele) => {
            if (ele.name === name) {
              return ele;
            }
          });
          if (eleList.length > 0) {
            return eleList[0];
          }
        }
        return null;
      },
      getWhiteSpaceCroppedImageData: function (canvas) {
        const context = canvas.getContext("2d");
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const imgData = context.getImageData(0, 0, imgWidth, imgHeight).data;
        const getRGB = function (x, y) {
          return {
            red: imgData[(imgWidth * y + x) * 4],
            green: imgData[(imgWidth * y + x) * 4 + 1],
            blue: imgData[(imgWidth * y + x) * 4 + 2]
          };
        };
        const isWhite = function (rgb) {
          // We're getting zeroes instead of 255 in each pixel that is blank (makes it hard to detect black pixels).
          // The color of non-blank pixels will be either blue or (almost) black. So if any pixel has three equal
          // values, it is "white".
          return rgb.red === rgb.blue && rgb.blue === rgb.green;
        };
        const scanY = function (fromTop) {
          let offset = fromTop ? 1 : -1;

          // loop through each row
          for (let y = fromTop ? 0 : imgHeight - 1; fromTop ? y < imgHeight : y > -1; y += offset) {
            // loop through each column
            for (let x = 0; x < imgWidth; x++) {
              if (!isWhite(getRGB(x, y))) {
                return y;
              }
            }
          }
          return fromTop ? 0 : imgHeight; // all image is white
        };
        const scanX = function (fromLeft) {
          let offset = fromLeft ? 1 : -1;

          // loop through each column
          for (let x = fromLeft ? 0 : imgWidth - 1; fromLeft ? x < imgWidth : x > -1; x += offset) {
            // loop through each row
            for (let y = 0; y < imgHeight; y++) {
              if (!isWhite(getRGB(x, y))) {
                return x;
              }
            }
          }
          return fromLeft ? 0 : imgWidth; // all image is white
        };
        const cropTop = scanY(true);
        const cropBottom = scanY(false);
        const cropHeight = cropBottom - cropTop;
        const cropLeft = scanX(true);
        const cropRight = scanX(false);
        const cropWidth = cropRight - cropLeft;
        if (cropHeight < imgHeight || cropWidth < imgWidth) {
          const cropCanvas = $("<canvas>")[0];
          cropCanvas.width = cropWidth;
          cropCanvas.height = cropHeight;
          const cropContext = cropCanvas.getContext("2d");
          cropContext.drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
          return {
            width: cropWidth,
            height: cropHeight,
            url: cropCanvas.toDataURL()
          };
        }
        // No cropping is possible, return image Url for original canvas.
        return {
          width: imgWidth,
          height: imgHeight,
          url: canvas.toDataURL()
        };
      },
      buildSigData: function (data) {
        let buffer = [];
        for (let idx in data) {
          if (data.hasOwnProperty(idx)) {
            let node = data[idx];
            buffer.push(node.lx);
            buffer.push(node.ly);
            buffer.push(node.mx);
            buffer.push(node.my);
          }
        }
        return buffer.join();
      }
    };
    window.dynamicDialogs = [];
    this.__dialogHelper.prototype = {
      createDialog: function (dialogBody, dialogOptions) {
        try {
          //set any default input values for jquery dialog
          let defaultDialogOptions = {
            autoOpen: true,
            modal: true,
            buttons: {
              "Submit": function () {
                $(this).dialog("close");
              },
              "Cancel": function () {
                $(this).dialog("close");
              }
            }
          };

          //getting user's input values for jquery dialog
          dialogOptions = _objectSpread(_objectSpread({}, defaultDialogOptions), dialogOptions);

          //get a reference to the container element
          let dynamicDialogsContainer = __g_zPDF_formHelper__.lwcTemplate.querySelector(".dynamic-dialogs-container");

          //every time we create a new dialog we would be creating a new div inside the dynamic dialog container div
          //create a new div for the new dialog & and append the dialog body inside this new div
          let newDialogDiv = document.createElement("div");
          $(newDialogDiv).html(dialogBody);
          let dialogReference = $(newDialogDiv).dialog(dialogOptions);
          window.dynamicDialogs.push(dialogReference);
          return dialogReference;
        } catch (err) {
          console.error("an error has occured while creating the dialog : ", err);
          return null;
        }
      },
      destroyAllDialogs: function () {
        console.group("destroy all dialogs");
        console.log("1");
        if (window.dynamicDialogs && window.dynamicDialogs.length) {
          console.log("2");
          //destroy all dialogs
          window.dynamicDialogs.forEach(dialog => {
            $(dialog).dialog("destroy");
          });
          console.log("3");
          //clear out all html elements (if any)
          let dynamicDialogsContainer = __g_zPDF_formHelper__.lwcTemplate.querySelector(".dynamic-dialogs-container");
          while (dynamicDialogsContainer.lastElementChild) {
            dynamicDialogsContainer.remove(dynamicDialogsContainer.lastElementChild);
          }
        }
        console.groupEnd();
      }
    };
  }
  connectedCallback() {
    let self = this;
    console.log('@@@@ Main Pane is added to DOM @@@@');
    registerListener(eventTypes.TOGGLE_WALLET, this.loadSrcWallet, self); //ORV240129 register TOGGLE_WALLET event which is fired from panel.js
    registerListener(eventTypes.PDF_LOADED, this.handlePdfLoaded, this);
    registerListener(eventTypes.SHOW_PDF_PAGE, this.handleShowPage, this);
    registerListener('pageChange', pageChangeEvent => {
      console.log("page change event invoked");
      window.__g_zPDF_formHelper__.preserveCurPageFormElements(self.__pageInfo___.curPage, self.__docInfo___);
      console.log("queueRenderPage 2");
      this.queueRenderPage(pageChangeEvent.selectedPageNumber, 0);
    }, this);
    //listen to persona update event from zpaper-person component
    registerListener(eventTypes.PERSONA_UPDATE, personaUpdateEvent => {
      //AHS260511+Claude - persona change swaps HTML hidden field on mobile
      console.log("received persona update event ", personaUpdateEvent);
      self.selectedPersona = personaUpdateEvent.detail.selectedValue;
      self.selectedPersona = self.selectedPersona + "Data";
      __g_zPDF_formHelper__.getSendToOptions(self.selectedPersona);
      if (window.__g_isMobile && self._htmlAttachments) {
        //AHS260511+Claude - swap HTML on persona change using cached hidden fields
        const newPersona = personaUpdateEvent.detail.selectedValue;
        const htmlContent = newPersona ? self._htmlAttachments[newPersona.toLowerCase() + '.html'] : null;
        if (htmlContent) {
          console.log("AHS260511+Claude persona changed, loading HTML hidden field for: " + newPersona);
          const blob = new Blob([htmlContent], {
            type: 'text/html'
          });
          const zipFileDiv = self.template.querySelector(".zip-file-content");
          const mainPaneDiv = self.template.querySelector(".main-pane-content");
          const iframe = zipFileDiv.querySelector("iframe");
          if (iframe.src) URL.revokeObjectURL(iframe.src); //AHS260511+Claude - revoke previous blob URL to prevent memory leak
          iframe.src = URL.createObjectURL(blob);
          const isFirstLoad = zipFileDiv.classList.contains("slds-hidden"); //AHS260511+Claude - only init toolbar on first switch to HTML view
          mainPaneDiv.classList.add("slds-hidden");
          zipFileDiv.classList.remove("slds-hidden");
          if (isFirstLoad) {
            fireEvent(self.pageRef, "initialize-zplib", {
              htmlFile: true
            });
          }
        }
      }
    }, this); //binding an empty JSON object (with pageRef) as a value for "this"
    registerListener(eventTypes.ZOOM_OUT, zoomOutEvent => {
      self.zoomOut();
    }, self);
    registerListener(eventTypes.ZOOM_IN, zoomInEvent => {
      self.zoomIn();
    }, self);
    registerListener(eventTypes.LOCAL_FILE_UPLOAD, localFileUploadEvent => {
      if (localFileUploadEvent.fileName) {
        __g_title = localFileUploadEvent.fileName;
      } else {
        __g_title = '';
      }
      self.isLocalFileUpload = true;
      self.localFileData = localFileUploadEvent.localFileData;

      //AHS230317 - Initialize form helper with each new document loaded
      self.__g_zPDF_formHelper__ = new self.__formHelper();
      window.__g_zPDF_formHelper__ = self.__g_zPDF_formHelper__;
      self.loadingDefaultPdf = false;
      self.source = localFileUploadEvent.source;
      self.sourceUrl = localFileUploadEvent.sourceUrl;
      self.isBookmarkedPDF = localFileUploadEvent.isBookmarkedPDF;
      //AHS260226+Claude: allow event callers to specify which toolbar tab opens by default,
      // overriding the URL 't' param. Must be set before loadPDF() so zpLib reads the
      // updated value when initilizeToolbar runs after the async pdfjs load completes.
      if (localFileUploadEvent.defaultToolbar) {
        __g_defaultToolbar = localFileUploadEvent.defaultToolbar;
      }
      //CRN211108 Save the file input element to submit with input/signature data if needed.
      window.__g_zPDF_formHelper__.localFile = localFileUploadEvent.file;
      self.loadPDF();
    }, self);
    registerListener(eventTypes.LOAD_UNSEEN_PAGES, loadUnseenPagesEvent => {
      const unseenPages = loadUnseenPagesEvent.detail.unseenPages;
      const curPage = loadUnseenPagesEvent.detail.curPage;
      const eventSource = loadUnseenPagesEvent.detail.source;
      const enforceRequiredFields = loadUnseenPagesEvent.detail.enforceRequiredFields;
      const responseData = {
        source: eventSource
      };
      if (unseenPages && unseenPages.length > 0) {
        let pagesToLoad = !unseenPages.includes(curPage) ? [...unseenPages, curPage] : unseenPages; // The current page is added to the pagesToLoad so that the last page form elements will be captured.
        let i = -1;
        let pageLoadInterval = setInterval(() => {
          if (!self.isPageLoading) {
            i++;
            if (i >= pagesToLoad.length) {
              fireEvent(self.pageRef, eventTypes.LOADED_UNSEEN_PAGES, responseData);
              //$(".loading-overlay").fadeOut();
              clearInterval(pageLoadInterval);
              return;
            }
            const pageNumber = pagesToLoad[i]; //AHS240612
            const pageRotation = __g_pageRotation[pageNumber - 1] || 0; //AHS240612 - get roation info
            self.queueRenderPage(pageNumber, pageRotation, enforceRequiredFields).catch(err => {
              //AHS240612 - updated params to queueRender page, added rotaion info
              console.warn(`Error thrown while rendering page ${err}. Halting the loading of all pages.`);
              clearInterval(pageLoadInterval);
              return;
            });
          }
        }, 200);
      } else {
        fireEvent(self.pageRef, eventTypes.LOADED_UNSEEN_PAGES, responseData);
        //$(".loading-overlay").fadeOut();
      }
    }, self);
    registerListener(eventTypes.PUBLISH_ATTACHMENT_FORM_DATA, publishAttachmentFormDataEvent => {
      console.log("received form data ", publishAttachmentFormDataEvent);
      self.__g_zPDF_formHelper__.attachmentFormData = publishAttachmentFormDataEvent.attachmentFormData;
    }, self);

    //if parent does not load the pdf , lead the pdf by self
    if (!this.parentLoadsPdf) {
      console.log("**************** parent not loading pdf *******************");
      this.loadPDF();
    }
    console.log("pdfViewerMainPane - connectedCallback");
    console.log(this.template.querySelector(".pdfPage"));
    console.log(this.template.querySelector(".pdfPageOverlay"));
    registerListener(eventTypes.MODAL_POP_UP, event => {
      $(this.docTypeModal).dialog("open");
      if (window.__g_isMobile) {
        __fixMobileDialogStyle($('.ui-dialog'));
      }
    }, self);

    /**  ORV231220  set persona on load start*/
    let personaData = personaService.names();
    if (!getSelectedPersona()) {
      // should we use selectedPersonaVal
      let preSelectedPersona = window.localStorage.getItem("selectedPersona");
      let personaLst = window.localStorage.getItem("personas"); //OV 231215 persona list
      if (preSelectedPersona && personaLst.includes(preSelectedPersona)) {
        //OV 231215 check if preSelectedPersona is present in personaLst else selected default persona
        setSelectedPersona(preSelectedPersona);
      } else {
        setSelectedPersona(personaData[0]);
      }
    }
    /**  ORV231220 set persona on load end*/
  }
  disconnectedCallback() {
    unregisterAllListeners(this);
  }

  //ahs - start
  renderedCallback() {
    let self = this;
    if (!window.__g_zPDF_formHelper__.lwcTemplate) {
      window.__g_zPDF_formHelper__.lwcTemplate = self.template;
    }
    this.__$containerDiv = $(this.template.querySelector('.main-pane-content'));

    //show jquery confirmation dialog 1st
    this.__$lockConfirmationDialog = $(this.template.querySelector(".lock-confirmation-dialog")).dialog({
      autoOpen: false,
      modal: true,
      buttons: {
        "Agree": function () {
          //lock all the fields if the user has agreed to sign
          __g_zPDF_signatureHelper__.agreedToSign();
          $(this).dialog("close");
        },
        "Cancel": function () {
          //if cancel is clicked uncheck the lock checkbox on pdf
          if (self.template.querySelectorAll(".buttonWidgetAnnotation input[name='X_reviewedStatus']").length > 0) {
            $(self.template.querySelectorAll(".buttonWidgetAnnotation input[name='X_reviewedStatus']")).prop("checked", false);
          }
          $(this).dialog("close");
        }
      },
      open: (event, ui) => {
        if (!__g_JqueryCloseBtn) {
          $(".ui-dialog-titlebar-close").hide();
        }
      },
      close: (event, ui) => {
        //if "x" button is clicked uncheck the lock checkbox on pdf
        if ($(event.currentTarget).hasClass('ui-dialog-titlebar-close')) {
          if (self.template.querySelectorAll(".buttonWidgetAnnotation input[name='X_reviewedStatus']").length > 0) {
            $(self.template.querySelectorAll(".buttonWidgetAnnotation input[name='X_reviewedStatus']")).prop("checked", false);
          }
        }
      }
    });
    $(".agreed-to-sign", this.__$lockConfirmationDialog).on("change", checkEvt => {
      let isAgreedToSign = $(".agreed-to-sign", self.__$lockConfirmationDialog).is(":checked");
      $(".ui-dialog-buttonpane button:contains('Agree')").button(isAgreedToSign ? "enable" : "disable");
    });
    if (!this.eventFired && window.noURLParameter) {
      this.eventFired = true;
      fireEvent(self.pageRef, "initialize-zplib", {
        pdfPage: self.template.querySelector(".pdfPage"),
        pdfPageOverlay: self.template.querySelector(".pdfPageOverlay"),
        pdfViewerMainPaneTemplate: self.template,
        pdfViewerMainPane: self,
        //passing this component for reference in toolbarButton component
        //pdfDoc: doc //sending the doc object directly was breaking the code without any error message
        //as a work around passing a json pdfInfo separately
        loadBasicToolbar: true,
        pdfInfo: {
          numPages: 0
        },
        loadingDefaultPdf: self.loadingDefaultPdf,
        source: self.source,
        sourceUrl: self.sourceUrl
      });
    }
    /*
    if(!this.recursiveCall){
        this.recursiveCall = true;
      this.docTypeModal =  $(this.template.querySelector(".docTypeModal")).dialog({
            autoOpen: false,
            modal: true
        });
    }
    */
    if (!__g_isPMainPaneCmpLoaded) {
      __g_isPMainPaneCmpLoaded = true;
    }
  }
  //ahs - end
  docSelection(event) {
    this.selectedDocType = event.target.value;
  }
  handleShowPdf(evt) {
    console.log("formViewer: Event received => ", evt);
    this.loadingDefaultPdf = evt.detail.loadingDefaultPdf;
    //AHS260226+Claude: allow event callers to specify which toolbar tab opens by default
    if (evt.detail.defaultToolbar) {
      __g_defaultToolbar = evt.detail.defaultToolbar;
    }
    this.loadPDF(evt.detail);
    // This event should be fired in the pdfViewer that contains all viewer pieces; it should be the controlling component.
    // let event = new CustomEvent(eventTypes.SHOW_TOOLS, {bubbles: true, cancelable: true});
    // fireEvent(this.pageRef, eventTypes.SHOW_TOOLS, event);
    // event = new CustomEvent(eventTypes.SHOW_DE_PANEL, {bubbles: true, cancelable: true});
    // fireEvent(this.pageRef, eventTypes.SHOW_DE_PANEL, event);
  }
  handleShowPage(evt) {
    this.queueRenderPage(evt.detail.pageNumber, evt.detail.pageRotation);
  }
  parseHostFromUrl(protocol, url) {
    if (__g_protocol === 'file') {
      return 'file';
    }
    url = decodeURIComponent(url); // decode if necessary...
    let idxBegin = url.indexOf("://") > 0 ? url.indexOf("://") + 3 : 0;
    if (idxBegin == 0) {
      return __g_hostname; //SHR220113 handle local api/xxx calls
    }
    let idxEnd = url.indexOf('/', idxBegin);
    if (idxEnd < 0) {
      return url.substring(idxBegin);
    }
    return url.substring(idxBegin, idxEnd);
  }
  loadPDF(snippetId) {
    try {
      let self = this;
      console.log("@@@ snippetId = " + snippetId);
      //SHR220113 moved to index.html // let pdfUrl = `api/viewForm?id=${snippetId}`;
      let pdfUrl = __g_requestedPdf;
      if (__g_requestedPdf) {
        //SHR220113 moved to index.html // pdfUrl = `api/no-zippi/getUrl?get=${__g_requestedPdf}`;
        let host = this.parseHostFromUrl(__g_protocol, __g_requestedPdf);
        console.log("Requested PDF host => " + host);
        console.log("Host that served up this UI => " + __g_hostname);
        if ('file' === host || host === __g_hostname) {
          // Just pull the url directly using AJAX if it is coming from the same host that served up this UI.
          // I don't think the local file will work because of cross-site protections, but we'll see.
          pdfUrl = decodeURIComponent(__g_requestedPdf);
        } else if (!isApiServerAvailable) {
          //CRN211206 Restoring the wget functionality that is needed when we are running the client from
          // /kb/client directory.
          pdfUrl = pdfUrl.replace(/.*\?/, '/kb/client/wget.jsp?');
        }
      }
      //checking if local file is uploaded
      if (self.isLocalFileUpload) {
        pdfUrl = self.localFileData;
        self.isLocalFileUpload = false;
      }
      console.log("Pulling PDF from url => " + pdfUrl);

      // let loadingTask = pdfjsLib.getDocument(pdfUrl, pdfHeaders);
      let loadingTask = pdfjsLib.getDocument(pdfUrl);
      loadingTask.promise.then(async function (doc) {
        //AHS260511+Claude - async to support mobile HTML hidden field check
        if (window.__g_isMobile) {
          //AHS260511+Claude - on mobile, look for HTML hidden fields before rendering PDF
          try {
            self._htmlAttachments = await extractHtmlFromHiddenFields(doc); //AHS260511+Claude - parse and store for persona switches
            if (self._htmlAttachments) {
              const persona = getSelectedPersona();
              const htmlContent = persona ? self._htmlAttachments[persona.toLowerCase() + '.html'] : null;
              if (htmlContent) {
                console.log("AHS260511+Claude mobile HTML hidden field found for persona: " + persona);
                const blob = new Blob([htmlContent], {
                  type: 'text/html'
                });
                const zipFileDiv = self.template.querySelector(".zip-file-content");
                const mainPaneDiv = self.template.querySelector(".main-pane-content");
                zipFileDiv.querySelector("iframe").src = URL.createObjectURL(blob);
                mainPaneDiv.classList.add("slds-hidden");
                zipFileDiv.classList.remove("slds-hidden");
                window.__g_zPDF_formHelper__.lwcTemplate = self.template; //AHS260530+Claude - set lwcTemplate so HTML toolbar buttons (clear26/learn26/fill26) can find .zipFile-iframe
                hideSpinner(); //AHS260512+Claude - hide spinner since postLoadPdfActivities is skipped
                fireEvent(self.pageRef, "initialize-zplib", {
                  htmlFile: true
                });
                return; //AHS260511+Claude - skip PDF rendering, HTML loaded instead
              }
            }
          } catch (e) {
            console.warn("AHS260511+Claude HTML hidden field extraction failed, falling back to PDF rendering", e);
          }
        }
        self.postLoadPdfActivities(doc);
      }).catch(error => {
        self.postLoadPdfActivitiesCatch();
      });
    } catch (e) {
      console.log("Error loading pdf page: " + e);
    }
  }
  postLoadPdfActivities(doc) {
    let self = this;
    self.___pdfDoc___ = doc;
    let buffer = "",
      maxPages = doc.numPages;
    //making the pdf doc globally available
    window.__g_pdfDoc___ = doc;

    //initializing the formHelper every time the document is loaded
    window.__g_zPDF_formHelper__.pagesInfo = self.__pageInfo___;
    window.__g_zPDF_formHelper__.docInfo = self.__docInfo___;
    window.__g_zPDF_formHelper__.lwcTemplate = self.template;
    window.__g_zPDF_formHelper__.pdfAppObject = self.__pdfAppObject;
    window.__g_zPDF_formHelper__.pdfEventObject = self.__pdfEventObject;
    window.__g_zPDF_formHelper__.mainPane = self; // setting a reference to main pane controller in the form helper object itself

    //initializing the signHelper every time the document is loaded
    // Preserve the kbSubmitForm URL so that we can use it if the user opens a local file that contains a signature.
    let sigURL = null;
    if (window.__g_zPDF_signatureHelper__ && window.__g_zPDF_signatureHelper__.sigURL) {
      sigURL = window.__g_zPDF_signatureHelper__.sigURL;
    }
    window.__g_zPDF_signatureHelper__ = new self.__sigHelper();
    self.__sigHelper.prototype.reinitializePrototype(); // ORV230110 reinitialize __sigHelper prototype on pdf load
    window.__g_zPDF_signatureHelper__.pagesInfo = self.__pageInfo___;
    window.__g_zPDF_signatureHelper__.lwcTemplate = self.template;
    window.__g_zPDF_signatureHelper__.lwcComponent = self;
    window.__g_zPDF_signatureHelper__.sigURL = sigURL;
    window.__g_zPDF_formHelper__.__sigHelper = window.__g_zPDF_signatureHelper__;
    window.__g_zPDF_formHelper__.attachmentFormData = new FormData();
    window.__g_zPDF_dialogHelper = new self.__dialogHelper();

    // set browser title
    doc.getMetadata().then(metadata => {
      let metadataInfo = metadata.info;
      // SHR240228: Save the custom properties into the formHelper for FHIR import to use
      // SHR240307: Due to custom property size limits, each field mapping has its own property
      window.__g_zPDF_formHelper__.mapJson = {};
      // SHR240307: Fallback - parse the JSON mapping string
      if (metadataInfo?.Mapping) {
        window.__g_zPDF_formHelper__.mapJson = JSON.parse(metadataInfo.Mapping);
      }
      // When pdfjs supports Custom properties, then we can iterate
      for (let key in metadataInfo) {
        if (key.startsWith("Mapping/")) {
          let mapKey = key.substring(8);
          let mapVal = metadataInfo[key];
          if (mapVal?.trim().length) {
            window.__g_zPDF_formHelper__.mapJson[mapKey] = mapVal;
          }
        }
      }
      if (metadataInfo?.Title && !__g_title) {
        //ORV240116 check if metadataInfo.Title is defined; AHS260228+Claude: only use PDF metadata title as fallback if real filename not already set from Drive/local
        __g_title = metadataInfo.Title;
      }
      //ORV250313 security error in Salesforce while updating document.title as sprkz is running in the iframe so added a check to know that to identify if sprz is runing in iframe or top level
      if (window.self == window.top) {
        if (__g_title) {
          window.top.document.title = __g_title;
        } else {
          window.top.document.title = "SprkZ by zPaper";
        }
      }
    }).catch(err => {
      console.error("Title update error", err);
    }).finally(() => {
      console.log("fireEvent", fireEvent);
      if (!self.isBookmarkedPDF) {
        fireEvent(self.pageRef, "initialize-zplib", {
          pdfPage: self.template.querySelector(".pdfPage"),
          pdfPageOverlay: self.template.querySelector(".pdfPageOverlay"),
          pdfViewerMainPaneTemplate: self.template,
          pdfViewerMainPane: self,
          //passing this component for reference in toolbarButton component
          //pdfDoc: doc //sending the doc object directly was breaking the code without any error message
          //as a work around passing a json pdfInfo separately
          pdfInfo: {
            numPages: doc.numPages
          },
          loadingDefaultPdf: self.loadingDefaultPdf,
          source: self.source,
          sourceUrl: self.sourceUrl
        });
        // hide zipFileDiv iframe which displays nonPdf Files
        let zipFileDiv = __g_zPDF_formHelper__.lwcTemplate.querySelector(".zip-file-content");
        if (zipFileDiv && !zipFileDiv.classList.contains("slds-hidden")) {
          zipFileDiv.classList.add("slds-hidden");
        }
      } else {
        //we are not initializing the toolbar
        //using another event to pass new formHelper, sigHelper & pdfDoc object to the toolbars button
        fireEvent(self.pageRef, eventTypes.REFRESH_TOOLBAR_DATA, {
          formHelper: __g_zPDF_formHelper__,
          sigHelper: __g_zPDF_signatureHelper__,
          pdfDoc: __g_pdfDoc___
        });
      }
      hideSpinner();
    });

    //clear out old event handlers
    if (!self.isBookmarkedPDF) {
      clearTrackedListeners();
    }

    //switch between x-ray and canvas view
    self.template.querySelector(".main-pane-content").classList.remove("slds-hidden");
    self.template.querySelector(".x-ray-content").classList.add("slds-hidden");

    //clear all dialogs
    //self.__dialogHelper.destroyAllDialogs();

    console.log("pdfPage", self.template.querySelector(".pdfPage"));
    console.log("pdfPageOverlay", self.template.querySelector(".pdfPageOverlay"));
    console.log("pdfViewerMainPaneTemplate", self.template);
    //console.log("toolbarButtons", toolbarButtons);
    //console.log("doc", doc);

    //ahs added end
    self.renderFirstPage(doc);
    if ("kb" === __g_toolbarType) {
      if (0 === $('#zToolsParent').length) {
        zAddTools(1);
        for (var i = 1; i <= doc.numPages; i++) {
          buffer += "<option" + (i == 1 ? " selected='selected'" : "") + " value='javascript:queueRenderPage(" + i + ")'>page " + (i + 0) + "</option>";
        }
        window.console.log("@@@ Customizing the toolbar @@@");
        customizeToolbar(buffer, self);
      }
    }
  }
  postLoadPdfActivitiesCatch() {
    let self = this;
    window.__g_zPDF_formHelper__.lwcTemplate = self.template;

    //clear out old event handlers
    if (!self.isBookmarkedPDF) {
      clearTrackedListeners();
    }
    showError("An eror has occured while loading the PDF");
    fireEvent(self.pageRef, "initialize-zplib", {
      loadingDefaultPdf: true,
      pdfPage: self.template.querySelector(".pdfPage"),
      pdfPageOverlay: self.template.querySelector(".pdfPageOverlay"),
      pdfViewerMainPaneTemplate: self.template,
      pdfViewerMainPane: self,
      pdfInfo: {
        numPages: 0
      }
    });
    hideSpinner();
    //should we be creating entire toolbar if we have an error or provide an option to the user for
    // if ("kb" !== __g_toolbarType) {
    //     //this code here will throw error : ReferenceError: __g_zPDF_formHelper__ is not defined
    //     fireEvent(self.pageRef, "initialize-zplib", {
    //         pdfPage: self.template.querySelector(".pdfPage"),
    //         pdfPageOverlay: self.template.querySelector(".pdfPageOverlay"),
    //         pdfViewerMainPaneTemplate: self.template,
    //         pdfViewerMainPane: self, //passing this component for reference in toolbarButton component
    //         //pdfDoc: doc //sending the doc object directly was breaking the code without any error message
    //         //as a work around passing a json pdfInfo separately
    //         pdfInfo: {
    //             numPages: 0
    //         },
    //         source : self.source
    //     });
    // }
    // else {
    //     if (0 === $('#zToolsParent').length) {
    //         zAddTools(1);
    //         //we would not have access to doc as the loading task has failed
    //         for (var i = 1; i <= doc.numPages; i++) {
    //             //this code here will throw error do we have access to buffer & doc vriables?
    //             buffer += "<option" + (i == 1 ? " selected='selected'" : "") + " value='javascript:queueRenderPage(" + i + ")'>page " + (i + 0) + "</option>";
    //         }
    //         window.console.log("@@@ Customizing the toolbar @@@");
    //         customizeToolbar(buffer, self);
    //     }
    // }
  }
  handlePdfLoaded(evt) {
    let self = this;
    self.source = evt.detail.source;
    self.sourceUrl = evt.detail.sourceUrl;
    if (evt.detail.fileName) {
      __g_title = evt.detail.fileName;
    }
    try {
      // Initialize form helper with each new document loaded
      let oldFormHelper = window.__g_zPDF_formHelper__;
      self.__g_zPDF_formHelper__ = new self.__formHelper();
      window.__g_zPDF_formHelper__ = self.__g_zPDF_formHelper__;
      window.__g_zPDF_searchHelper__ = new self.__searchHelper();

      //CRN211115 Preserve the localFile if necessary.
      if (oldFormHelper) {
        window.__g_zPDF_formHelper__.localFile = oldFormHelper.localFile;
        window.__g_zPDF_formHelper__.sigURL = oldFormHelper.sigURL;
        window.__g_zPDF_formHelper__.kbupPreservedValue = oldFormHelper.kbupPreservedValue;
      }
      if (evt.detail.success) {
        self.isLocalFileUpload = true;
        self.localFileData = evt.detail.doc;
        window.__g_zPDF_formHelper__.currentFileData = evt.detail.doc;
        self.loadingDefaultPdf = evt.detail.loadingDefaultPdf;
        self.fillOnLoad = evt.detail.fillOnLoad;
        self.selectedPersona = evt.detail.selectedPersona;
        self.isBookmarkedPDF = evt.detail.isBookmarkedPDF;
        //AHS260226+Claude: allow event callers to specify which toolbar tab opens by default
        if (evt.detail.defaultToolbar) {
          __g_defaultToolbar = evt.detail.defaultToolbar;
        }
        console.log("evt : ", evt);
        console.log("self.fillOnLoad : ", self.fillOnLoad);
        console.log("self.fillOnLoad : ", evt.detail.isBookmarkedPDF);
        self.loadPDF();
        //this.postLoadPdfActivities(evt.detail.doc);
      } else {
        self.source = evt.detail.source;
        self.sourceUrl = evt.detail.sourceUrl;
        console.log("main pane => before catch");
        this.postLoadPdfActivitiesCatch();
        console.log("main pane => after catch");
      }
    } catch (err) {
      console.error("An error has occured in post load activities");
      this.postLoadPdfActivitiesCatch();
    }
  }
  //ORV240129 call loadSrcWallet when panel.js is loaded
  loadSrcWallet(evt) {
    if (evt.enableWallet) {
      this.displaywallet = evt.enableWallet;
      this.walletSrc = evt.src;
    }
  }
  /*
      <form accept-charset="UTF-8" enctype="application/x-www-form-urlencoded" method="post" class="formContainer">
          <input type="hidden" id="X_markup" name="X_markup" />
          <input type="hidden" id="X_sigImage" name="X_sigImage" />
          <input type="hidden" id="X_sigSizing" name="X_sigSizing" />
      </form>
    */
  renderFirstPage(doc) {
    let self = this;
    let pdfPageDiv = this.template.querySelector('.pdfPage');
    this.___pdfDoc___ = doc;
    this.__pageInfo___.pageCount = doc.numPages;
    this.__pageInfo___.curPage = 1; //OV reset the cur page to defaul 1, as 1st page is opened when new pdf is opened
    // Add the __pageInfo___ to the global scope so that it can be passed to the toolbar (we need the curPageView
    // object to map from screen coordinates to pdf coordinates.
    window.__pageInfo___ = this.__pageInfo___;
    if (this.__pageInfo___.curPageView) {
      // We've shown a previous pdf document, so get rid of all of the old stuff, both javascipt and html dom
      this.__pageInfo___.curPageView.destroy();
      delete this.__pageInfo___.curPageView;
      this.__pageInfo___.curPageView = null;

      // Remove the dom elements that were previously used to display the PDF.
      let child = pdfPageDiv.lastElementChild;
      while (child) {
        pdfPageDiv.removeChild(child);
        child = pdfPageDiv.lastElementChild;
      }

      //Remove all elements in X-Ray div
      let xRayDiv = this.template.querySelector(".x-ray-content");
      let xRayChild = xRayDiv.lastElementChild;
      while (xRayChild) {
        xRayDiv.removeChild(xRayChild);
        xRayChild = xRayDiv.lastElementChild;
      }
    }
    delete this.__docInfo___.pagesFormData;
    this.__docInfo___.pagesFormData = {};
    window.__g_zPDF_formHelper__.docInfo = this.__docInfo___;
    let mainPageDiv = this.__pageInfo___.container;
    if (!mainPageDiv) {
      // mainPageDiv = document.createElement("div");
      // this.__pageInfo___.curPageDiv = mainPageDiv;
      // mainPageDiv.style.padding = "2px";
      let mainPagePanel = pdfPageDiv;
      // mainPagePanel.style.padding = "2px";
      // let formContainer = document.createElement("form");
      // formContainer.classList.add("formContainer");
      // formContainer.setAttribute("accept-charset", "UTF-8");
      // formContainer.setAttribute("enctype", "application/x-www-form-urlencoded");
      // formContainer.setAttribute("method", "post");
      // mainPagePanel.appendChild(formContainer);
      this.__pageInfo___.container = mainPagePanel;
      // mainPagePanel.appendChild(mainPageDiv);
      // let canvas = document.createElement("canvas");
      // canvas.style.border = "1px solid black";
      //
      // // keep 8.5 x 11 aspect ratio
      // canvas.width = 600;
      // canvas.height = 776;
      // // I can't use a class here because, for some reason, it screws up the scale of the rendered page.
      // // canvas.className = "pdfCanvas";
      // mainPageDiv.appendChild(canvas);
      // this.__pageInfo___.canvas = canvas;

      /*
                  // If we do this, we have to do it after the page has rendered because that is when the parent div will have
                  // any children.
                  let children = mainPagePanel.children;
                  for (let i = 0; i < children.length; i++) {
                      var child = children[i];
                      child.width = '100%';
                      child.height = '100%';
                  }
      */
    }
    //ORV240208 get page ratotion so when the pdf is loaded rotation of 1st is maintained
    doc.getPage(1).then(function (page) {
      return self.queueRenderPage(1, page.rotate);
    }).then(() => {
      //we would need to check for single page fill instead of all page fill
      if (self.fillOnLoad) {
        // window.__g_zPDF_formHelper__.fillFormData(); //AHS231004 - move learn funciton outside pdfViewerMainPane
        // fillFormData.call(__g_zPDF_formHelper__, getSelectedPersona()); //AHS231004 - move learn funciton outside pdfViewerMainPane
        fillFormData(getSelectedPersona()); //AHS231006 // Confirm the call for fillFormData
      }
    });
  }
  queueRenderPage(pageNum, rotation = 0, enforceRequiredFields) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.isPageLoading = true;
      // Preserve the form field values if required (won't need to do this if this is the first page to ever be displayed).
      if (self.__pageInfo___.curPage > 0) {
        try {
          self.__g_zPDF_formHelper__.preserveCurPageFormElements(self.__pageInfo___.curPage, self.__docInfo___, enforceRequiredFields);
        } catch (err) {
          self.isPageLoading = false;
          showError(`${err} You must fill in required fields.`);
          reject(err);
          return;
        }

        //adding rotation information to current page
        self.__pageInfo___.rotationHasChanged = self.__pageInfo___.curPageRotation == rotation ? false : true;
        self.__pageInfo___.curPageRotation = rotation;
      }
      // Use a promise to fetch and render the next page.
      let promise = Promise.resolve();
      promise = promise.then(function (pageNum) {
        return self.___pdfDoc___.getPage(pageNum).then(function (pdfPage) {
          let pageInfo = self.__pageInfo___;
          let cleanPromise = Promise.resolve();
          cleanPromise.then(function () {
            // Since we want to enable text mode, we always have to rebuild the curPageView. If we don't rebuild it, the text layer will be blank.
            // if (pageInfo.zoomHasChanged || pageInfo.rotationHasChanged) {//adding check to see if rotation has changed
            pageInfo.zoomHasChanged = false;
            pageInfo.rotationHasChanged = false;
            if (pageInfo.curPageView) {
              pageInfo.curPageView.destroy();
              // The destroy doesn't get rid of the pdf div. Do that now.
              $(pageInfo.curPageView.div).remove();
              delete pageInfo.curPageView;
              pageInfo.curPageView = null;
              $('#formContainer').children('.page').remove();
              //self.template.querySelector('.page').remove();
            }
            // }
          }).then(function () {
            // Create the page view if necessary
            if (!pageInfo.curPageView) {
              console.log("Enabling text mode. Is the text selectable/searchable?");
              pageInfo.curPageView = new pdfjsViewer.PDFPageView({
                // container: self.__pageInfo___.canvas,
                container: self.__pageInfo___.container,
                id: pageNum,
                scale: pageInfo.curZoomScale,
                //defaultViewport: pdfPage.getViewport({ scale: pageInfo.curZoomScale }),
                defaultViewport: pdfPage.getViewport(pageInfo.curZoomScale, pageInfo.curPageRotation),
                annotationLayerFactory: new pdfjsViewer.DefaultAnnotationLayerFactory(),
                renderInteractiveForms: true,
                textLayerFactory: new pdfjsViewer.DefaultTextLayerFactory(),
                textLayerMode: 2
              });
            }
            pageInfo.curPage = pageNum;

            // Associate the actual page with the view and draw it.
            pageInfo.curPageView.setPdfPage(pdfPage);
            return pageInfo.curPageView.draw();
          }).then(function () {
            // The page has been rendered; time to restore any form values, if necessary.
            // restoreCurPageFormElements method is called only when canvas is visible because it not restore the data for xray when rendered
            let mainPaneContent = __g_zPDF_formHelper__.lwcTemplate?.querySelector(".main-pane-content");
            if (!mainPaneContent.classList.contains("slds-hidden")) {
              self.__g_zPDF_formHelper__.restoreCurPageFormElements(pageInfo.curPage, self.__docInfo___);
            }
            self.__g_zPDF_formHelper__.addValidation();
            if (__g_zPDF_signatureHelper__.lockedForSigning) {
              // lock the elements if the user is currently signing
              __g_zPDF_signatureHelper__.prepareToSign();
            }
            //CRN211025 Adding support for signature submission to local files. Check here if the "Lock to Sign"
            // checkbox and "Send" button need to be added.
            if (1 === pageNum) {
              //CRN220124 Hardcode the zippi url for the demo
              // let jobsUrl = "/api/zippi/jobs/PDF?templateId=" + __g_templateId +
              //     (__g_recordId ? "&recordId=" + __g_recordId : "");
              if (!__g_zPDF_formHelper__.sigURL) {
                let jobsUrl = isApiServerAvailable ? "/r/sprkz/jobs" : "/kb/jsp/SF_sendFax.jsp"; //added a flag to check if we are working with an api server //ORV241210 update jobs "zippi/jobs" urls //Todo confirm with ":/kb/jsp/SF_sendFax.jsp"
                // Don't do this. Handle it in submitKBForm().
                // jobsUrl = "/kb/jsp/SF_sendFax.jsp";
                __g_zPDF_formHelper__.setSendToDestination(jobsUrl, true);
              }
              __g_zPDF_formHelper__.addSendAndSignatureElementsIfNecessary();
            }

            // Event listeners to enable the Zoom UI
            self.EnableZoomUI(pageInfo.curPageView);
            self.isPageLoading = false;
            //ORV231211 86a1n07cx  fire PDF_PAGE_LOADED when pdf is loaded
            fireEvent(self.pageRef, eventTypes.PDF_PAGE_LOADED, {
              pageNumber: pageNum,
              rotation: rotation
            });
            //  self.__g_zPDF_formHelper__.restoreCurPageFormElements(pageInfo.curPage, self.__docInfo___); //ORV test it remove later
          });
        }).catch(err => {
          self.isPageLoading = false;
          reject(err);
        });
      }.bind(null, pageNum));
    });
  }
  onPrevPage() {
    if (this.__pageInfo___.curPage <= 1) {
      return;
    }
    let curPage = this.__pageInfo___.curPage - 1;
    var tb = document.getElementById("toolbarGoTo");
    if (tb) tb.selectedIndex = curPage - 1; //ERS150905
    this.queueRenderPage(curPage);
  }

  /**
   * Displays next page.
   */
  onNextPage() {
    if (this.__pageInfo___.curPage >= this.___pdfDoc___.numPages) {
      return;
    }
    let curPage = this.__pageInfo___.curPage + 1;
    var tb = document.getElementById("toolbarGoTo");
    if (tb) tb.selectedIndex = curPage - 1; //ERS150905
    this.queueRenderPage(curPage);
  }
  zoomIn() {
    //this.__pageInfo___.curZoomScale = zoomLevel / 100;
    if (this.__pageInfo___.curZoomScale < 2.25) {
      this.__pageInfo___.curZoomScale += 0.125;
      this.__pageInfo___.zoomHasChanged = true;
      this.queueRenderPage(this.__pageInfo___.curPage, this.__pageInfo___.curPageRotation);
    } else {
      showWarning("Maximum zoom in limit reached", 4000);
    }
  }
  zoomOut() {
    //this.__pageInfo___.curZoomScale = zoomLevel / 100;
    if (this.__pageInfo___.curZoomScale > 0.25) {
      this.__pageInfo___.curZoomScale -= 0.125;
      this.__pageInfo___.zoomHasChanged = true;
      this.queueRenderPage(this.__pageInfo___.curPage, this.__pageInfo___.curPageRotation);
    } else {
      showWarning("Maximum zoom out limit reached", 4000);
    }
  }
  zoom(zoomLevel) {
    this.__pageInfo___.curZoomScale = zoomLevel / 100;
    this.__pageInfo___.zoomHasChanged = true;
    this.queueRenderPage(this.__pageInfo___.curPage);
  }
  EnableZoomUI(pageview) {
    let uiDisabled = true;
    if (uiDisabled) {
      return;
    }
    let context2d = pageview.canvas.getContext('2d');
    let zoomLevel = 1;
    let scaleFactor = 2.0;
    let originX = 0,
      originY = 0;
    let clickedX = 0,
      clickedY = 0,
      clickedPt = {};
    pageview.canvas.addEventListener('mousedown', function (evt) {
      document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
      clickedX = evt.offsetX || evt.pageX - pageview.canvas.offsetLeft;
      clickedY = evt.offsetY || evt.pageY - pageview.canvas.offsetTop;
      clickedPt = getCanvasPoint(clickedX, clickedY);
      console.log("clicked:", clickedPt);
    }, false);
    pageview.canvas.addEventListener('mouseup', function (evt) {
      var droppedX = evt.offsetX || evt.pageX - pageview.canvas.offsetLeft;
      var droppedY = evt.offsetY || evt.pageY - pageview.canvas.offsetTop;
      var droppedPt = getCanvasPoint(droppedX, droppedY);

      // Panned -- unless the dragged distance is "close to zero"
      var draggedX = droppedPt.x - clickedPt.x;
      var draggedY = droppedPt.y - clickedPt.y;
      if (draggedX ** 2 + draggedY ** 2 < 5) {
        var direction = evt.shiftKey ? -1 : 1;
        var zoomPower = Math.pow(scaleFactor, direction);
        var nextLevel = zoomLevel * zoomPower;

        // Zoomed -- translate the page origin based on the clicked point
        draggedX = droppedPt.x * (1 - zoomPower);
        draggedY = droppedPt.y * (1 - zoomPower);
        originX = originX * zoomPower - draggedX;
        originY = originY * zoomPower - draggedY;
        zoomLevel = nextLevel;
      } else {
        console.log("dropped:", droppedPt);
        originX -= draggedX;
        originY -= draggedY;
      }
      updatePage();
    }, false);
    var updatePage = function () {
      if (uiDisabled) {
        return; //SHR191218 update the canvas in the viewer only, not editable forms
      }
      var transform = [zoomLevel, 0, 0, zoomLevel, -originX, -originY];
      console.log("transform:", transform);

      // update the Zoom-level control
      var sel = document.getElementById("zoomSelect");
      sel.options[0].label = 100 * zoomLevel.toFixed(2) + "%";
      sel.options[0].value = zoomLevel;
      sel.options[0].selected = true;

      // redraw the transformed page
      pageview.pdfPage.render({
        canvasContext: context2d,
        transform: transform,
        viewport: pageview.viewport
      });
    };
    function getCanvasPoint(x, y) {
      var viewHeight = pageview.viewport.viewBox[3];
      var viewScale = pageview.viewport.scale;
      var pt = pageview.getPagePoint(x, y);

      // invert the y-axis coordinate
      pt[1] = viewHeight - pt[1];
      // adjust to the viewport scale
      pt[0] = viewScale * pt[0];
      pt[1] = viewScale * pt[1];
      return {
        x: Math.round(pt[0]),
        y: Math.round(pt[1])
      };
    }
  }
  docSelection(event) {
    this.selectedDocType = event.target.value;
  }

  /*
  closeDocModal(){
      this.docTypeModal = false;
  }
  submitDoc(){
      let event=new CustomEvent(eventTypes.DOCTYPE_BROADCAST,{
          detail: {
              docType : this.selectedDocType
          },
          bubbles: true,
          cancelable: true
      });
       fireEvent(this.pageRef, eventTypes.DOCTYPE_BROADCAST, event);
       $(this.docTypeModal).dialog("close");
  }
  */

  hideInfoToast() {
    let infoToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".info-notification"));
    $(infoToast).addClass("slds-hidden");
  }
  hideErrorToast() {
    let errorToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".error-notification"));
    $(errorToast).addClass("slds-hidden");
  }
  hideSuccessToast() {
    let successToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".success-notification"));
    $(successToast).addClass("slds-hidden");
  }
  hideWarningToast() {
    let warningToast = $(__g_zPDF_formHelper__.lwcTemplate.querySelector(".warning-notification"));
    $(warningToast).addClass("slds-hidden");
  }
}
_registerDecorators(PdfViewerMainPane, {
  publicProps: {
    parentLoadsPdf: {
      config: 0
    }
  },
  publicMethods: ["queueRenderPage"],
  fields: ["sendtotxtval", "DEFAULT_SCALE", "___pdfDoc___", "__pageInfo___", "__docInfo___", "selectedDocType", "eventFired", "isLocalFileUpload", "localFileData", "displaywallet", "walletSrc", "pageRef", "__g_zPDF_formHelper__", "__$containerDiv", "dynamicDialog", "loadingDefaultPdf", "source", "sourceUrl", "__formHelper", "__sigHelper", "__searchHelper", "__pdfEventObject", "__pdfAppObject", "__dialogHelper", "isPageLoading", "fillOnLoad", "selectedPersona", "isBookmarkedPDF"]
});
export default _registerComponent(PdfViewerMainPane, {
  tmpl: _tmpl
});